function debounce(fn, delay) {
  let timer = null;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}

//自定义：to top悬浮按钮
class BackToTopButton extends HTMLElement {
  constructor() {
    super()
    this.handleScroll = this.handleScroll.bind(this)
    this.addEventListener("click", () => {
      window.scrollTo({ top: 0, behavior: "smooth" })
    })
  }

  connectedCallback() {
    window.addEventListener("scroll", this.handleScroll)
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.handleScroll)
  }

  handleScroll() {
    const viewportHeight = window.innerHeight
    const scrollPosition = window.scrollY || document.documentElement.scrollTop
    if (scrollPosition > viewportHeight + 280) {
      this.classList.add("show")
    } else {
      this.classList.remove("show")
    }
  }
}

if (!window.customElements.get("back-to-top-button")) {
  customElements.define("back-to-top-button", BackToTopButton)
}

//自定义：产品页附加产品功能
class AdditionalProducts extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.registerClickEvents()
    this.jointName() //默认先展示一次None
  }
  registerClickEvents() {
    this.querySelectorAll(".product-block-wrap").forEach((item) => {
      item.addEventListener("click", () => {
        if (item.classList.contains("active")) {
          item.classList.remove("active")
        } else {
          item.classList.add("active")
        }
        this.jointName()
      })
    })
  }
  jointName() {
    const allActiveWraps = this.querySelectorAll(".product-block-wrap.active")
    const optionValue = this.querySelector(".option-value")
    let jointText = Array.from(allActiveWraps).reduce((prev, item) => {
      const title = item.querySelector(".title").innerText + " / "
      return (prev += title)
    }, "")
    if (jointText.length > 0) {
      jointText = jointText.slice(0, -3)
    }
    optionValue.innerText = jointText || "None"
  }
}

if (!window.customElements.get("additional-products")) {
  customElements.define("additional-products", AdditionalProducts)
}

//自定义：三十六小时达
class dayAndHalfArrival extends HTMLElement {
  constructor() {
    super()
  }
  connectedCallback() {
    this.dynamicCompute()
    this.addEventListener("click",()=>{
      if(window.matchMedia("(max-width: 767px)").matches){
        this.openDialog()
      }
    })
  }
  openDialog(){
    document.dispatchEvent(new CustomEvent("day-and-half-modal"))
  }
  dynamicCompute(){
    const arrivalTime = this.querySelector('#day-and-half-arrival-time');
    const afterDaysArrival = +this.getAttribute("some-day-arrival")
    if (!arrivalTime) return;
    const date = new Date();
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    // 计算 4 天后的日期
    const severalDaysLater = new Date(date.getTime() + afterDaysArrival * 24 * 60 * 60 * 1000);

    const severalDaysLaterDay = severalDaysLater.getDate();
    const severalDaysLaterMonth = months[severalDaysLater.getMonth()];
    const severalDaysLaterFormattedDate = `${severalDaysLaterMonth}.${severalDaysLaterDay}`;

    // 更新页面显示 4 天后的到货日期
    arrivalTime.innerHTML = severalDaysLaterFormattedDate;
  }
}

if (!window.customElements.get("day-and-half-arrival")) {
  customElements.define("day-and-half-arrival", dayAndHalfArrival)
}

/* 
参数：
white-modal-id：white-modal的id，等于white-modal.liquid的modal_type参数
pc-modal-id：pc-modal的id，等于pc-modal.liquid的modal_type参数
white-modal-height-factor：white-modal的高度因子，通常是0 - 1之间的小数

inner-id: 如果是多个内容共用弹窗的话，那具体展示哪个内容，需要通过此id指定
*/
class dialogButton extends HTMLElement {
  constructor() {
    super()
    // 绑定this
    this.initPhoneWhiteModal = this.initPhoneWhiteModal.bind(this)
    this.commonModal = this.hasAttribute("common-modal")
    if(this.commonModal) {
      this.h5CommonModalShowDom = document.querySelector(`.white-modal #${this.getAttribute("inner-id")}`)
      this.pcCommonModalShowDom = document.querySelector(`pc-modal #${this.getAttribute("inner-id")}`)
    } else {
      this.h5CommonModalShowDom = document.querySelector("#h5-comparison-modal")
    }

    this.whiteModalId = this.getAttribute("white-modal-id")
    this.pcModalId = this.getAttribute("pc-modal-id")
    this.whiteModalHeightFactor = parseFloat(this.getAttribute("white-modal-height-factor")) || 0.15

    // 缓存DOM元素，避免重复查询
    this.modal = document.querySelector(`#${this.whiteModalId}`)
    this.modalContent = this.modal.querySelector(".white-modal-content")
    this.modalInner = this.modal.querySelector(".white-modal-inner")

    // 业务逻辑
    this.addEventListener("click", this.handleClick)
    this.initPhoneWhiteModal()
  }
  
  initPhoneWhiteModal() {
    const _this = this
    this.modal.addEventListener("click", function (event) {
      // 检查点击是否在 .white-modal-content 区域之外
      if (!event.target.closest(".white-modal-content") || event.target.closest(".white-modal-close")) {
        _this.closePhoneWhiteModal()
      }
    })
    this.modalContent.addEventListener("scroll", function (event) {
      event.stopPropagation()
      if (event.cancelable) {
        event.preventDefault()
      }
    })
  }

  handleClick() {
    // 判断设备是否为手机
    const isMobile = window.matchMedia("(max-width: 767px)").matches
    if (isMobile) {
      this.openPhoneWhiteModal()
      document.body.style.overflow = 'hidden';
    } else {
      this.openPcModal()
    }
  }
  openPcModal() {
    this.listenPcModalClose()
    const pcModal = document.querySelector(`#${this.pcModalId}`)
    if(this.commonModal) {
      this.pcCommonModalShowDom.classList.remove("hidden")
    }
    if (pcModal) {
      pcModal.style.display = "block"
    }
  }
  listenPcModalClose() {
    document.addEventListener("dialog:close", (info)=>{
      console.log("info.detail.dialogType:",info.detail.dialogType)
      if(info.detail.dialogType == this.getAttribute("pc-modal-type")){
        this.pcCommonModalShowDom.classList.add("hidden")
      }
    })
  }
  openPhoneWhiteModal() {
    if(this.commonModal) {
      this.h5CommonModalShowDom.classList.remove("hidden")
    }
    this.modal.style.display = "block"

    setTimeout(() => {
      // 计算顶部位置
      let viewportHeight = window.innerHeight
      let modalTopAttrValue = viewportHeight * this.whiteModalHeightFactor
      // 应用计算后的顶部位置
      this.modalContent.style.top = modalTopAttrValue + "px"
    }, 10) // 小的超时来触发过渡
  }

  closePhoneWhiteModal() {
    document.body.style.overflow = "unset";
    this.modalContent.style.top = "100%"
    setTimeout(() => {
      this.h5CommonModalShowDom.classList.add("hidden")
      this.modal.style.display = "none"
    }, 300) // 与CSS过渡时间匹配
  }
}

// 注册自定义元素
if (!window.customElements.get("dialog-button")) {
  customElements.define("dialog-button", dialogButton)
}

class PcModal extends HTMLElement {
  constructor() {
    super()
    this._modal = this.querySelector(".modal-content")
    this.modalType = this.getAttribute("modal-type")
    this._closeButton = this.querySelector(".close")
    // 打开和关闭模态框的功能
    this.open = this.open.bind(this)
    this.close = this.close.bind(this)

    // 监听关闭按钮的点击事件
    if (this._closeButton) {
      this._closeButton.addEventListener("click", this.close)
    }

    // 监听点击模态框外部时关闭模态框
    this.addEventListener("click", (event) => {
      if (event.target === this) {
        this.close()
      }
    })
  }

  // 打开模态框
  open() {
    this.style.display = "block"
    this._modal.classList.remove("modal-hide")
  }

  // 关闭模态框
  close() {
    if(this.modalType){
      const event = new CustomEvent("dialog:close",{
        detail: {
          dialogType: this.modalType
        },
      })
      document.dispatchEvent(event) // 触发事件
    }
    this.style.display = "none"
  }
}
if (!window.customElements.get("pc-modal")) {
  // 定义自定义元素
  customElements.define("pc-modal", PcModal)
}

/* media-compose-marquee中用到了video，该组件开启自动播放 */
class videoBesideMaquee extends HTMLElement {
  constructor() {
    super()
    setTimeout(() => {
      this._playVideo()
    }, 0);
  }
  _playVideo(){
    this.videoMedia = this.querySelector("video-media")
    this.videoMedia.play({ restart: true });
  }
}
if (!window.customElements.get("video-beside-maquee")) {
  // 定义自定义元素
  customElements.define("video-beside-maquee", videoBesideMaquee)
}

// js/development/sliderTabs.js
import { animate as animate50 } from "vendor";
var sliderTabs = class extends HTMLElement {
  static get observedAttributes() {
    return ["selected-index"];
  }
  constructor() {
    super();
    this.slider = this.querySelector(".slider");
    if (!this.shadowRoot) {
      this.attachShadow({ mode: "open" }).appendChild(this.querySelector("template").content.cloneNode(true));
    }
    if (Shopify.designMode) {
      this.addEventListener("shopify:block:select", (event) => this.selectedIndex = this.buttons.indexOf(event.target));
    }
    this.addEventListener("keydown", this._handleKeyboard);
    document.addEventListener("swiperOfSliderTabs:change", debounce(this._changeTabByIndex.bind(this), 300));
  }
  connectedCallback() {
    this._abortController = new AbortController();
    this.buttons = Array.from(this.shadowRoot.querySelector('slot[name="title"]').assignedNodes(), (item) => item.matches("button") && item || item.querySelector("button"));
    this.panels = Array.from(this.shadowRoot.querySelector('slot[name="content"]').assignedNodes());
    this.buttons.forEach((button, index) => button.addEventListener("click", () => {
      this.selectedIndex = index
      const event = new CustomEvent("sliderTabs:change", {
        detail: {
          index: index,
        },
      })
      document.dispatchEvent(event) // 触发事件
    }, { signal: this._abortController.signal }));
    this.selectedIndex = this.selectedIndex;
    this._setupAccessibility();
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
  get animationDuration() {
    return this.hasAttribute("animation-duration") ? parseFloat(this.getAttribute("animation-duration")) : 0.15;
  }
  get selectedIndex() {
    return parseInt(this.getAttribute("selected-index")) || 0;
  }
  set selectedIndex(index) {
    this.setAttribute("selected-index", Math.min(Math.max(index, 0), this.buttons.length - 1).toString());
    this.style.setProperty("--selected-index", this.selectedIndex.toString());
    this.style.setProperty("--item-count", this.buttons.length.toString());
  }
  attributeChangedCallback(name, oldValue, newValue) {
    this.buttons.forEach((button, index) => button.setAttribute("aria-selected", index === parseInt(newValue) ? "true" : "false"));
    if (name === "selected-index" && oldValue !== null && oldValue !== newValue) {
      this._transitionTab(this.slider, parseInt(newValue));
      this._transitionContent(this.panels[parseInt(oldValue)], this.panels[parseInt(newValue)]);
    }
  }
  _setupAccessibility() {
    const componentID = crypto.randomUUID ? crypto.randomUUID() : Math.floor(Math.random() * 1e4);
    this.buttons.forEach((button, index) => {
      button.setAttribute("role", "tab");
      button.setAttribute("aria-controls", `tab-panel-${componentID}-${index}`);
      button.id = `tab-${componentID}-${index}`;
    });
    this.panels.forEach((panel, index) => {
      panel.setAttribute("role", "tabpanel");
      panel.setAttribute("aria-labelledby", `tab-${componentID}-${index}`);
      panel.id = `tab-panel-${componentID}-${index}`;
      panel.hidden = index !== this.selectedIndex;
    });
  }
  _changeTabByIndex(event) {
    const index = event.detail.index;
    if (index >= 0 && index < this.buttons.length) {
      this.selectedIndex = index;
    }
  }
  /**
   * As per https://www.w3.org/WAI/ARIA/apg/example-index/tabs/tabs-automatic.html, when a tab is currently focused,
   * left and right arrow should switch the tab
   */
  _handleKeyboard(event) {
    const index = this.buttons.indexOf(document.activeElement);
    if (index === -1 || !["ArrowLeft", "ArrowRight"].includes(event.key)) {
      return;
    }
    if (event.key === "ArrowLeft") {
      this.selectedIndex = (this.selectedIndex - 1 + this.buttons.length) % this.buttons.length;
    } else {
      this.selectedIndex = (this.selectedIndex + 1 + this.buttons.length) % this.buttons.length;
    }
    this.buttons[this.selectedIndex].focus();
  }
  /**
   * Perform a custom transition (can be overridden in subclasses). To "from" and "to" are hash representing the panel
   */
  async _transitionTab(slider, toIndex) {
    await animate50(slider, { x: `${toIndex * 100}%` }, { duration: 0.3, easing: "ease-in-out" }).finished;
  }
  async _transitionContent(fromPanel, toPanel) {
    await animate50(fromPanel, { opacity: [1, 0] }, { duration: this.animationDuration }).finished;
    fromPanel.hidden = true;
    toPanel.hidden = false;
    await animate50(toPanel, { opacity: [0, 1] }, { duration: this.animationDuration }).finished;
  }
};
if (!window.customElements.get("slider-tabs")) {
  window.customElements.define("slider-tabs", sliderTabs);
}

// js/development/sliderTabsPcCarousel.js
// 将轮播图抽到单独的组件中【其实就应该这样抽，但是代码当中有一些是<script></script>去弄的】
var sliderTabsPcCarousel = class extends HTMLElement {
  constructor() {
    super();
    this.actualSlideNum = parseInt(this.getAttribute("actual-slide-num"));
    this.stretchValue = parseInt(this.getAttribute("stretch-value")) || -120
    document.addEventListener("sliderTabs:change", this._changeSlideByIndex.bind(this));
    if(!window.matchMedia("(max-width: 767px)").matches) {
      this.targetSwiper = this._initPcSwiper();
      this._listenSwiperChange(this.targetSwiper);
    }
  }
  _initPcSwiper() {
    const targetDom = this.querySelector(".swiper-container");
    if(!targetDom) return null;
    return new Swiper(targetDom, {
      effect: 'coverflow',
      centeredSlides: true,
      slidesPerView: 1.5, // ✅ 显示1.5个slide，两边各漏一点
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      coverflowEffect: {
        rotate: 0,
        stretch: this.stretchValue, // ✅ 负值让两侧图片稍微收缩
        depth: 800,
        modifier: 1,
        slideShadows: true, // ✅ 关闭阴影，按需调整
      },
    });
  }
  _listenSwiperChange(targetSwiper) {
    const tempActualSlideNum = this.actualSlideNum
    targetSwiper.on('realIndexChange', function () {
      const event = new CustomEvent("swiperOfSliderTabs:change", {
        detail: { //因为swiper在3个slide的时候，存在bug时，所以liquid中处理了代码，同时这里也要处理。
          index: tempActualSlideNum > 3 ? targetSwiper.realIndex : (targetSwiper.realIndex % tempActualSlideNum),
        },
      });
      document.dispatchEvent(event); // 触发事件
    });
  }
  _changeSlideByIndex(event) {
    const index = event.detail.index;
    if(this.targetSwiper) {
      this.targetSwiper.slideToLoop(index);
    }
  }
}
if (!window.customElements.get("slider-tabs-pc-carousel")) {
  window.customElements.define("slider-tabs-pc-carousel", sliderTabsPcCarousel);
}

var variantSwitchDeliveryInterests = class extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.prevTargetEleClass = ""
    this._variantPickerChange();
  }
  _variantPickerChange() {
    let formElement = document.querySelector('.product-info__buy-buttons>.shopify-product-form');
    let idInput = formElement.querySelector('input[name="id"]');
    idInput.addEventListener('change', (event) => {
      this._handleArrivalTimeShow(event.target.value)
    });
    this._handleArrivalTimeShow(idInput.value)
  }
  _handleArrivalTimeShow(variantId) {
    if(this.prevTargetEleClass){
      const prevTargetEle = document.querySelector(this.prevTargetEleClass)
      if(prevTargetEle) prevTargetEle.style.display = "none"
    }
    const targetEleClass = `.dev-interests-wrap.belong_${variantId}`
    const targetEle = this.querySelector(targetEleClass)
    if(targetEle) {
      this.prevTargetEleClass = targetEleClass
      targetEle.style.display = "flex"
    } else {
      const targetEle = this.querySelector(".default-interests-wrap")
      this.prevTargetEleClass = ".dev-interests-wrap.default-interests-wrap"
      targetEle.style.display = "flex"
    }
  }
}
if (!window.customElements.get("variant-switch-delivery-interests")) {
  window.customElements.define("variant-switch-delivery-interests", variantSwitchDeliveryInterests);
}

var variantSwitchImageBoard = class extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.prevTargetEleClass = ""
    this._variantPickerChange();
  }
  _variantPickerChange() {
    let formElement = document.querySelector('.product-info__buy-buttons>.shopify-product-form');
    let idInput = formElement.querySelector('input[name="id"]');
    idInput.addEventListener('change', (event) => {
      this._handleImageBoardShow(event.target.value)
    });
    this._handleImageBoardShow(idInput.value)
  }
  _handleImageBoardShow(variantId) {
    if(this.prevTargetEleClass){
      const prevTargetEle = document.querySelector(this.prevTargetEleClass)
      if(prevTargetEle) prevTargetEle.style.display = "none"
    }
    const targetEleClass = `.image-board-wrap.belong_${variantId}`
    const targetEle = this.querySelector(targetEleClass)
    if(targetEle) {
      this.prevTargetEleClass = targetEleClass
      targetEle.style.display = "flex"
    } else {
      const targetEle = this.querySelector(".default-image-board-wrap")
      this.prevTargetEleClass = ".image-board-wrap.default-image-board-wrap"
      if(targetEle) targetEle.style.display = "flex"
    }
  }
}
if (!window.customElements.get("variant-switch-image-board")) {
  window.customElements.define("variant-switch-image-board", variantSwitchImageBoard);
}

// js/development/flat-swiper.js
// container-class：swiper-container的class【必填】
// enable-navigation：是否开启左右导航【可选】
// enable-pagination：是否开启分页【可选】
var flatSwiper = class extends HTMLElement {
  constructor() {
    super();
    if (this.hasAttribute("container-class")) {
      this._initPcSwiper();
    }
  }
  _initPcSwiper() {
    const targetDom = this.querySelector(`.${this.getAttribute("container-class")}`);
    if (!targetDom) return null;

    // 基础配置，只有 loop 属性
    const config = {
      loop: true,
    };

    // 如果有 enable-navigation 属性，则添加导航配置
    if (this.hasAttribute("enable-navigation")) {
      const nextEl = targetDom.querySelector(".swiper-button-next");
      const prevEl = targetDom.querySelector(".swiper-button-prev");
      if (nextEl && prevEl) {
        config.navigation = {
          nextEl: nextEl,
          prevEl: prevEl,
        };
      }
    }

    // 如果有 enable-pagination 属性，则添加分页配置
    if (this.hasAttribute("enable-pagination")) {
      const paginationEl = targetDom.querySelector(".swiper-pagination");
      if (paginationEl) {
        config.pagination = {
          el: paginationEl,
          clickable: true,
        };
      }
    }

    // 使用动态配置初始化 Swiper
    const swiper = new Swiper(targetDom, config);
  }
}

if (!window.customElements.get("flat-swiper")) {
  window.customElements.define("flat-swiper", flatSwiper);
}

// 左侧菜单切换右侧内容的自定义元素
class leftSwitchMegaMenu extends HTMLElement {
  constructor() {
    super();
    this.triggerType = this.getAttribute('trigger-type') || 'click';
    this.init();
  }

  init() {
    // 获取所有左侧菜单项
    this.menuItems = this.querySelectorAll('.left-menu-item');
    // 获取所有右侧面板
    this.panels = this.querySelectorAll('.second-third-level-panel');
    
    // 根据触发类型添加不同的事件监听
    if (this.triggerType === 'hover') {
      this.menuItems.forEach(item => {
        item.addEventListener('mouseenter', this.handleMenuItemClick.bind(this, item));
      });
    } else {
      this.menuItems.forEach(item => {
        item.addEventListener('click', this.handleMenuItemClick.bind(this, item));
      });
    }
  }

  handleMenuItemClick(clickedItem) {
    // 获取点击的菜单项索引
    const index = clickedItem.dataset.index;
    
    // 移除所有菜单项的active类
    this.menuItems.forEach(item => {
      item.classList.remove('active');
    });
    
    // 为点击的菜单项添加active类
    clickedItem.classList.add('active');
    
    // 隐藏所有面板
    this.panels.forEach(panel => {
      panel.classList.remove('active');
    });
    
    // 显示对应的面板
    const targetPanel = this.querySelector(`.second-third-level-panel[data-panel-index="${index}"]`);
    if (targetPanel) {
      targetPanel.classList.add('active');
      
      // 添加动画效果
      this.animatePanelChange(targetPanel);
    }
  }
  
  animatePanelChange(panel) {
    // 为面板添加简单的淡入效果
    panel.style.opacity = '0';
    panel.style.transform = 'translateY(10px)';
    
    // 使用requestAnimationFrame确保DOM更新后再应用动画
    requestAnimationFrame(() => {
      panel.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
      panel.style.opacity = '1';
      panel.style.transform = 'translateY(0)';
      
      // 清除过渡效果，以便下次切换
      setTimeout(() => {
        panel.style.transition = '';
      }, 300);
    });
  }
}

if (!window.customElements.get('left-switch-mega-menu')) {
  customElements.define('left-switch-mega-menu', leftSwitchMegaMenu);
}
class anchorWrap extends HTMLElement {
    constructor() {
        super()
        this.observer = null
        this.nthDom = parseInt(this.getAttribute("nth-dom")) || 1
        this.targetDom = this.getTargetDom()
        if (!this.targetDom) {
            return
        }
        this.rewriteAEle()
    }
    getTargetDom() {
        if (this.nthDom - 1 < 0) return null
        const targetDom = document.querySelectorAll(
            '[id^="shopify-section-template"]'
        )[this.nthDom - 1]
        const anchorWrapList = document.querySelectorAll("anchor-wrap")
        // 2. 创建一个 Intersection Observer 实例
        // 回调函数会在目标元素与根（root）交叉状态发生变化时被调用
        this.observer = new IntersectionObserver(
            (entries, observer) => {
                // entries 是一个 IntersectionObserverEntry 对象的数组
                // 每个 entry 代表一个被观察目标元素的变化
                entries.forEach((entry) => {
                    console.log
                    if (entry.isIntersecting) {
                        anchorWrapList.forEach((it) => {
                            it.classList.remove("anchor-wrap--active")
                        })
                        this.classList.add("anchor-wrap--active")
                    } else {
                        this.classList.remove("anchor-wrap--active")
                    }
                })
            },
            {
                root: null,
                rootMargin: "0px",
                threshold: 0.5,
            }
        )

        // 4. 开始观察目标元素
        this.observer.observe(targetDom)
        return targetDom || null
    }
    rewriteAEle() {
        const aEle = this.querySelector("a")
        const targetDomId = this.targetDom.getAttribute("id")
        console.log("aEle", aEle)
        console.log("targetDomId", targetDomId)

        if (!aEle || !targetDomId) {
            return
        }
        aEle.setAttribute("href", `#${targetDomId}`)
    }
    disconnectedCallback() {
        if (this.observer) {
            this.observer.disconnect()
        }
    }
}
if (!window.customElements.get("anchor-wrap")) {
    customElements.define("anchor-wrap", anchorWrap)
}


// 积分块自定义元素
class PointBlock extends HTMLElement {
  constructor() {
    super();
    this.isLoggedIn = this.hasAttribute('customer');
    this.isSignUp = this.getAttribute('identifier-name') === 'sign_up';
    this.blockLink = this.getAttribute('block-link');
  }

  connectedCallback() {
    // 添加适当的类名
    this.classList.add('point-block');
    
    // 如果是已登录状态且有链接且不是sign_up项，添加点击跳转功能
    if (this.isLoggedIn && this.blockLink && !this.isSignUp) {
      this.classList.add('clickable');
      this.addEventListener('click', this.handleBlockClick.bind(this));
    }

    // 如果是已登录用户且是sign_up项，添加achieved类
    if (this.isLoggedIn && this.isSignUp) {
      this.classList.add('achieved');
    }

    // 如果是未登录用户，添加登录overlay点击事件
    if (!this.isLoggedIn) {
      this.classList.add('not-logged-in');
      this.addEventListener('click', this.showLoginOverlay.bind(this));
    }
  }

  // 处理积分块点击事件，执行链接跳转
  handleBlockClick() {
    if (this.blockLink) {
      window.location.href = this.blockLink;
    }
  }

  // 显示登录overlay
  showLoginOverlay(event) {
    const overlay = this.querySelector('.sign-in-overlay');
    if (overlay) {
      overlay.classList.add('active');
      
      // 点击其他区域或登录按钮时隐藏overlay
      document.addEventListener('click', function hideOverlay(e) {
        if (!overlay.contains(e.target) && !this.contains(e.target) || overlay.contains(e.target)) {
          overlay.classList.remove('active');
          document.removeEventListener('click', hideOverlay);
        }
      }.bind(this));
    }
  }
}

if (!window.customElements.get('point-block')) {
  customElements.define('point-block', PointBlock);
}

class RedeemRewardsTabs extends HTMLElement {
  constructor() {
    super();
    this.tabLinks = this.querySelectorAll('.redeem-rewards__tab-link');
    this.tabPanels = this.querySelectorAll('.redeem-rewards__tab-panel');

    this.tabLinks.forEach(link => {
      link.addEventListener('click', this.handleTabClick.bind(this, link));
    });
  }

  handleTabClick(clickedLink) {
    const tabId = clickedLink.getAttribute('data-tab');

    this.tabLinks.forEach(item => item.classList.remove('active'));
    this.tabPanels.forEach(panel => panel.classList.remove('active'));

    clickedLink.classList.add('active');
    this.querySelector(`#${tabId}`).classList.add('active');
  }
}

if (!window.customElements.get('redeem-rewards-tabs')) {
  customElements.define('redeem-rewards-tabs', RedeemRewardsTabs);
}

// Slideshow add to cart 自定义元素
class SlideshowAddToCart extends HTMLElement {
  constructor() {
    super();
    this.variantId = this.getAttribute('variant-id');
    this.quantity = parseInt(this.getAttribute('quantity')) || 1;
    this.isLoading = false;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    // 为整个元素绑定点击事件
    this.addEventListener('click', (e) => {
      // 阻止轮播图控制按钮的冲突
      if (e.target.closest('.slideshow__controls') || 
          e.target.closest('button[is="prev-button"]') || 
          e.target.closest('button[is="next-button"]') ||
          e.target.closest('.numbered-dots') ||
          e.target.closest('.stretching-dots')) {
        return;
      }
      
      e.preventDefault();
      e.stopPropagation();
      this.handleAddToCart();
    });
  }

  async handleAddToCart() {
    if (this.isLoading || !this.variantId) {
      return;
    }

    this.isLoading = true;

    try {
      const formData = {
        'items': [{
          'id': parseInt(this.variantId),
          'quantity': this.quantity
        }]
      };

      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // 显示购物车抽屉
      const event = new CustomEvent("cart:show");
      document.dispatchEvent(event);
      document.dispatchEvent(new CustomEvent("cart:refresh"));

    } catch (error) {
      console.error('Error adding to cart:', error);
    } finally {
      this.isLoading = false;
    }
  }
}

// 注册自定义元素
if (!window.customElements.get('slideshow-add-to-cart')) {
  customElements.define('slideshow-add-to-cart', SlideshowAddToCart);
}

// 新的附加产品组件
class NewAdditionalProducts extends HTMLElement {
  constructor() {
    super();
    this.selectedProducts = new Set(); // 存储选中的产品ID
    this.isExpanded = false; // 展开状态
    this.collapsedMaxHeight = null; // 收起时的最大高度
  }

  connectedCallback() {
    this.init();
    
    // 延迟检查溢出状态，确保DOM完全渲染
    setTimeout(() => {
      this.checkOverflowAndGradient();
      this.checkExpandCollapseNeeded();
    }, 100);
    
    // 监听窗口大小变化，重新检查溢出状态
    this.resizeObserver = new ResizeObserver(() => {
      this.checkOverflowAndGradient();
      this.checkExpandCollapseNeeded();
    });
    this.resizeObserver.observe(this);
  }

  disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  init() {
    // 为每个产品项绑定点击事件
    this.querySelectorAll('.new-additional-product-item').forEach(item => {
      this.setupProductItem(item);
    });
    
    // 为展开/收起按钮绑定点击事件
    this.setupExpandCollapseButton();
  }
  
  setupExpandCollapseButton() {
    const wrapper = this.closest('.new-additional-products-wrapper');
    if (!wrapper) return;
    
    const expandBtn = wrapper.querySelector('.expand-collapse-btn');
    if (!expandBtn) return;
    
    expandBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      this.toggleExpandCollapse();
    });
  }
  
  checkExpandCollapseNeeded() {
    const items = this.querySelectorAll('.new-additional-product-item');
    const wrapper = this.closest('.new-additional-products-wrapper');
    if (!wrapper) return;
    
    const expandBtn = wrapper.querySelector('.expand-collapse-line');
    if (!expandBtn) return;
    
    // 如果产品数量 >= 4，则显示展开/收起按钮
    if (items.length >= 4) {
      this.style.paddingBottom = '30px';
      // 计算前3个产品的总高度
      this.calculateCollapsedHeight(items);
      
      // 显示按钮
      expandBtn.style.display = 'flex';
      
      // 初始状态为收起
      if (!this.isExpanded) {
        this.collapse();
      }
    } else {
      // 产品少于4个，隐藏按钮，移除高度限制
      expandBtn.style.display = 'none';
      this.style.maxHeight = 'none';
      wrapper.classList.remove('expanded');
    }
  }
  
  calculateCollapsedHeight(items) {
    // 计算前3个产品的总高度 + gap
    if (items.length < 3) return;
    
    let totalHeight = 0;
    const gap = 12; // gap between items
    
    for (let i = 0; i < 3; i++) {
      totalHeight += items[i].offsetHeight;
      if (i < 2) totalHeight += gap; // 添加gap，除了最后一个
    }
    
    // 添加padding-top
    totalHeight += 8;
    
    this.collapsedMaxHeight = totalHeight;
  }
  
  toggleExpandCollapse() {
    const wrapper = this.closest('.new-additional-products-wrapper');
    if (!wrapper) return;
    
    if (this.isExpanded) {
      this.collapse();
    } else {
      this.expand();
    }
  }
  
  collapse() {
    const wrapper = this.closest('.new-additional-products-wrapper');
    if (!wrapper) return;
    
    this.isExpanded = false;
    wrapper.classList.remove('expanded');
    
    // 设置最大高度为前3个产品的高度
    if (this.collapsedMaxHeight) {
      this.style.maxHeight = this.collapsedMaxHeight + 'px';
      this.style.overflow = 'hidden';
    }
  }
  
  expand() {
    const wrapper = this.closest('.new-additional-products-wrapper');
    if (!wrapper) return;
    
    this.isExpanded = true;
    wrapper.classList.add('expanded');
    
    // 移除高度限制
    this.style.maxHeight = 'none';
    this.style.overflow = 'hidden auto';
  }
  
  setupProductItem(item) {
    const selectBtn = item.querySelector('.product-select-btn');
    const variantSelect = item.querySelector('.variant-select');
    
    // 为整个产品项绑定点击事件
    item.addEventListener('click', (e) => {
      // 阻止点击选框和变体选择器时的默认行为
      if (e.target.closest('.product-select-btn') || e.target.closest('.variant-select')) {
        return;
      }
      this.toggleProductSelection(item);
    });

    // 为选择按钮绑定点击事件
    if (selectBtn) {
      selectBtn.addEventListener('click', (e) => {
        e.stopPropagation(); // 阻止冒泡到父元素
        this.toggleProductSelection(item);
      });
    }

    // 为变体选择器绑定变更事件
    if (variantSelect) {
      variantSelect.addEventListener('change', (e) => {
        e.stopPropagation(); // 阻止冒泡到父元素
        this.handleVariantChange(item, e.target);
      });
    }
  }

  toggleProductSelection(item) {
    const productData = this.getProductData(item);
    const isSelected = item.classList.contains('selected');
    
    if (isSelected) {
      // 取消选中
      item.classList.remove('selected');
      this.selectedProducts.delete(productData.id);
      this.updateSelectButton(item, false);
    } else {
      // 选中
      item.classList.add('selected');
      this.selectedProducts.add(productData.id);
      this.updateSelectButton(item, true);
    }

    // 触发自定义事件，通知其他组件
    this.dispatchEvent(new CustomEvent('selection-changed', {
      detail: {
        productId: productData.id,
        selected: !isSelected,
        selectedProducts: Array.from(this.selectedProducts)
      }
    }));

    // 重新检查是否需要显示渐变效果(表达可以往下滚动)
    setTimeout(() => {
      this.checkOverflowAndGradient();
    }, 0);
  }

  updateSelectButton(item, isSelected) {
    const unselectedIcon = item.querySelector('.unselected-icon');
    const selectedIcon = item.querySelector('.selected-icon');
    
    if (isSelected) {
      unselectedIcon.style.display = 'none';
      selectedIcon.style.display = 'block';
    } else {
      unselectedIcon.style.display = 'flex';
      selectedIcon.style.display = 'none';
    }
  }

  handleVariantChange(item, selectElement) {
    const selectedOption = selectElement.options[selectElement.selectedIndex];
    const productData = this.getProductData(item);
    
    // 获取变体数据
    const variantData = {
      id: selectedOption.value,
      price: selectedOption.dataset.price,
      comparePrice: selectedOption.dataset.comparePrice,
      image: selectedOption.dataset.image
    };

    // 更新产品显示信息
    this.updateProductDisplay(item, variantData, productData);
    
    // 触发变体变化事件，通知价格计算逻辑
    this.dispatchEvent(new CustomEvent('variant-changed', {
      detail: {
        productId: productData.id,
        variantId: variantData.id,
        variantData: variantData
      }
    }));
  }

  updateProductDisplay(item, variantData, productData) {
    // 更新图片
    const productImage = item.querySelector('.product-image img');
    if (productImage && variantData.image) {
      productImage.src = variantData.image;
    }

    // 更新价格
    const currentPriceElement = item.querySelector('.current-price');
    const comparePriceElement = item.querySelector('.compare-price');
    
    if (currentPriceElement) {
      const formattedPrice = this.formatPrice(variantData.price);
      currentPriceElement.textContent = `£${formattedPrice}`;
    }

    if (comparePriceElement) {
      const comparePrice = variantData.comparePrice;
      const price = variantData.price;
      
      // 检查 comparePrice 是否有效（不为 null、"null"、undefined 或空字符串）
      if (comparePrice && 
          comparePrice !== "null" && 
          comparePrice !== "" && 
          comparePrice !== null && 
          comparePrice !== "0" &&
          parseFloat(comparePrice) > 0 &&
          parseFloat(comparePrice) > parseFloat(price)) {
        const formattedComparePrice = this.formatPrice(comparePrice);
        comparePriceElement.textContent = `£${formattedComparePrice}`;
        comparePriceElement.style.display = 'inline';
      } else {
        comparePriceElement.style.display = 'none';
      }
    }
  }

  getProductData(item) {
    const dataScript = item.querySelector('.product-data');
    if (dataScript) {
      try {
        return JSON.parse(dataScript.textContent);
      } catch (e) {
        console.error('Error parsing product data:', e);
        return {};
      }
    }
    return {};
  }

  formatPrice(priceInCents) {
    return (parseFloat(priceInCents) / 100).toFixed(2);
  }

  // 检查是否需要显示渐变效果
  checkOverflowAndGradient() {
    const wrapper = this.closest('.new-additional-products-wrapper');
    if (!wrapper) return;

    // 检查内容是否产生滚动
    const scrollHeight = this.scrollHeight;
    const clientHeight = this.clientHeight;
    const hasVerticalScroll = scrollHeight > clientHeight;
    
    if (hasVerticalScroll) {
      wrapper.classList.add('show-gradient');
    } else {
      wrapper.classList.remove('show-gradient');
    }
  }

  // 获取所有选中的产品信息
  getSelectedProducts() {
    const selectedItems = this.querySelectorAll('.new-additional-product-item.selected');
    return Array.from(selectedItems).map(item => {
      const productData = this.getProductData(item);
      const variantSelect = item.querySelector('.variant-select');
      const selectedVariantId = variantSelect ? variantSelect.value : null;
      
      return {
        productId: productData.id,
        variantId: selectedVariantId,
        productData: productData
      };
    });
  }
}

// 注册自定义元素
if (!window.customElements.get('new-additional-products')) {
  customElements.define('new-additional-products', NewAdditionalProducts);
}

// 新的附加产品Tab容器组件 - 仅处理Tab切换，其他功能由NewAdditionalProducts处理
class NapTabsContainer extends HTMLElement {
  constructor() {
    super();
    this.activeTabIndex = 0;
  }

  connectedCallback() {
    this.tabButtons = this.querySelectorAll('.nap-tab-btn');
    this.tabPanels = this.querySelectorAll('.nap-tab-panel');
    
    this.tabButtons.forEach((btn, index) => {
      btn.addEventListener('click', () => this.switchTab(index));
    });
  }

  switchTab(index) {
    if (index === this.activeTabIndex) return;
    
    this.tabButtons.forEach((btn, i) => {
      btn.classList.toggle('active', i === index);
    });
    
    this.tabPanels.forEach((panel, i) => panel.classList.toggle('active', i === index));
    this.activeTabIndex = index;
  }
}

if (!window.customElements.get('nap-tabs-container')) {
  customElements.define('nap-tabs-container', NapTabsContainer);
}

// 新的附加产品组件
class TabAdditionalProducts extends HTMLElement {
  constructor() {
    super();
    this.selectedProducts = new Set(); // 存储选中的产品ID
    this.isExpanded = false; // 展开状态
    this.collapsedMaxHeight = null; // 收起时的最大高度
    this.singleSelectMode = false; // 单选模式
  }

  connectedCallback() {
    // 读取单选模式配置
    this.singleSelectMode = this.dataset.singleSelectMode === 'true';
    this.init();
    
    // 延迟检查溢出状态，确保DOM完全渲染
    setTimeout(() => {
      this.checkOverflowAndGradient();
      this.checkExpandCollapseNeeded();
    }, 100);
    
    // 监听窗口大小变化，重新检查溢出状态
    this.resizeObserver = new ResizeObserver(() => {
      this.checkOverflowAndGradient();
      this.checkExpandCollapseNeeded();
    });
    this.resizeObserver.observe(this);
  }

  disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  init() {
    // 为每个产品项绑定点击事件
    this.querySelectorAll('.new-additional-product-item').forEach(item => {
      this.setupProductItem(item);
    });
    
    // 为展开/收起按钮绑定点击事件
    this.setupExpandCollapseButton();
    // 为Shuffle按钮绑定点击事件
    this.setupShuffleButton();
  }
  
  setupExpandCollapseButton() {
    const expandBtn = this.querySelector('.expand-collapse-btn');
    if (!expandBtn) return;
    
    expandBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      this.toggleExpandCollapse();
    });
  }

  setupShuffleButton() {
    const shuffleBtn = this.querySelector('.shuffle-btn');
    if (!shuffleBtn) return;

    shuffleBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      debugger
      this.handleShuffle(shuffleBtn);
    });
  }

  async handleShuffle(btn) {
    if (this.isShuffling) return;
    this.isShuffling = true;
    btn.classList.add('rotating');

    try {
      this.shuffleProducts();
    } catch (e) {
      console.error('Shuffle error:', e);
    }

    setTimeout(() => {
      btn.classList.remove('rotating');
      this.isShuffling = false;
    }, 500);
  }

  shuffleProducts() {
    const poolScript = this.querySelector('.nap-data-pool');
    if (!poolScript) return;
    
    let poolData;
    try {
      poolData = JSON.parse(poolScript.textContent);
    } catch(e) {
      return;
    }

    const allProducts = poolData.products || [];
    const iconMap = poolData.icon_map || {};
    
    // 获取当前页面上存在的产品ID（包括选中的和未选中的）
    const currentItems = Array.from(this.querySelectorAll('.new-additional-product-item'));
    const currentIds = new Set();
    currentItems.forEach(item => {
      const data = this.getProductData(item);
      if (data && data.id) currentIds.add(data.id);
    });
    
    // 筛选出未选中的DOM元素（即需要被替换的位置）
    const candidates = currentItems.filter(item => !item.classList.contains('selected'));
    if (candidates.length === 0) return;

    // 从池子中筛选出不在当前页面上的产品
    const available = allProducts.filter(p => !currentIds.has(p.id));
    if (available.length === 0) return;

    // 加权随机打乱 (带有图标的产品权重更高)
    const shuffled = available.map(p => {
      // 检查是否有图标
      const hasIcon = !!iconMap[String(p.id)];
      // 权重: 有图标 1.3 (提升30%), 无图标 1.0
      const weight = hasIcon ? 30 : 1.0;
      // 使用加权随机分数 (Weighted Random Score)
      const score = Math.pow(Math.random(), 1 / weight);
      return { product: p, score: score };
    })
    .sort((a, b) => b.score - a.score)
    .map(item => item.product);

    // 替换逻辑
    candidates.forEach((item, index) => {
      if (index < shuffled.length) {
        this.replaceProductItem(item, shuffled[index], iconMap);
      }
    });
  }

  replaceProductItem(item, product, iconMap) {
    // 1. 更新 data-product-handle
    item.setAttribute('data-product-handle', product.handle);

    // 2. 更新 Corner Icon
    let cornerIcon = item.querySelector('.product-corner-icon');
    const iconUrl = iconMap[String(product.id)]; // Key is string in JSON
    
    if (iconUrl) {
      if (!cornerIcon) {
        cornerIcon = document.createElement('div');
        cornerIcon.className = 'product-corner-icon';
        const img = document.createElement('img');
        img.width = 60;
        img.height = 60; 
        img.loading = 'lazy';
        cornerIcon.appendChild(img);
        item.appendChild(cornerIcon);
      }
      const img = cornerIcon.querySelector('img');
      if (img) img.src = iconUrl;
      cornerIcon.style.display = 'block';
    } else {
      if (cornerIcon) cornerIcon.style.display = 'none';
    }

    // 3. 更新主图
    const mainImg = item.querySelector('.product-image img');
    if (mainImg) {
      mainImg.src = product.featured_image;
      mainImg.alt = product.title;
    }

    // 4. 更新标题
    const titleEl = item.querySelector('.product-title');
    if (titleEl) {
      titleEl.textContent = product.title;
    }

    // 5. 更新变体选择器
    const variantContainer = item.querySelector('.product-variant-selector');
    if (product.variants && product.variants.length > 1) {
      if (!variantContainer) {
        // 如果之前没有容器，创建一个，插入到 title 后面
        const newContainer = document.createElement('div');
        newContainer.className = 'product-variant-selector';
        const infoDiv = item.querySelector('.new-additional-product-info');
        if (infoDiv) {
            if (titleEl) {
                 infoDiv.insertBefore(newContainer, titleEl.nextSibling);
            } else {
                 infoDiv.appendChild(newContainer);
            }
        }
      }
      
      // 重新获取容器
      const container = item.querySelector('.product-variant-selector');
      if (container) {
        container.innerHTML = ''; // 清空
        container.classList.remove('hidden');
        container.style.display = ''; // 清除可能存在的内联样式
        const select = document.createElement('select');
        select.className = 'variant-select';
        select.name = `variant-${product.id}`;
        
        product.variants.forEach(v => {
          const opt = document.createElement('option');
          opt.value = v.id;
          opt.dataset.price = v.price;
          opt.dataset.comparePrice = v.compare_at_price || '';
          opt.dataset.image = v.image || '';
          opt.textContent = v.title;
          if (v.id === product.variants[0].id) opt.selected = true;
          select.appendChild(opt);
        });
        
        container.appendChild(select);
        
        // 重新绑定事件
        select.addEventListener('change', (e) => {
          e.stopPropagation();
          this.handleVariantChange(item, e.target);
        });
      }
    } else {
      if (variantContainer) {
        variantContainer.classList.add('hidden');
        variantContainer.style.display = ''; // 清除可能存在的内联样式
      }
    }

    // 6. 更新价格
    const currentPriceEl = item.querySelector('.current-price');
    if (currentPriceEl) {
      currentPriceEl.textContent = '$' + this.formatPrice(product.price);
    }
    
    const comparePriceEl = item.querySelector('.compare-price');
    if (comparePriceEl) {
      if (product.compare_at_price && product.compare_at_price > product.price) {
        comparePriceEl.textContent = '$' + this.formatPrice(product.compare_at_price);
        comparePriceEl.style.display = 'inline';
      } else {
        comparePriceEl.style.display = 'none';
      }
    }

    // 7. 更新隐藏的数据 Script
    const scriptData = item.querySelector('.product-data');
    if (scriptData) {
      scriptData.textContent = JSON.stringify(product);
    }

    // 8. 确保状态为未选中
    item.classList.remove('selected');
    this.updateSelectButton(item, false);
    
    // 如果有变体，初始化显示
    if (product.variants && product.variants.length > 0) {
        const firstVariant = product.variants[0];
        const variantData = {
          id: firstVariant.id,
          price: firstVariant.price,
          comparePrice: firstVariant.compare_at_price,
          image: firstVariant.image
        };
        this.updateProductDisplay(item, variantData, product);
    }
  }
  
  checkExpandCollapseNeeded() {
    const items = this.querySelectorAll('.new-additional-product-item');
    
    const expandBtn = this.querySelector('.expand-collapse-line');
    if (!expandBtn) return;
    
    // 如果产品数量 >= 4，则显示展开/收起按钮
    if (items.length >= 4) {
      this.style.paddingBottom = '20px';
      // 计算前3个产品的总高度
      this.calculateCollapsedHeight(items);
      
      // 显示按钮
      expandBtn.style.display = 'flex';
      
      // 初始状态为收起
      if (!this.isExpanded) {
        this.collapse();
      }
    } else {
      // 产品少于4个，隐藏按钮，移除高度限制
      expandBtn.style.display = 'none';
      this.style.maxHeight = 'none';
      this.classList.remove('expanded');
    }
  }
  
  calculateCollapsedHeight(items) {
    // 计算前3个产品的总高度 + gap
    if (items.length < 3) return;
    
    let totalHeight = 0;
    const gap = 12; // gap between items
    
    for (let i = 0; i < 3; i++) {
      totalHeight += items[i].offsetHeight;
      if (i < 2) totalHeight += gap; // 添加gap，除了最后一个
    }
    
    // 添加padding-top
    totalHeight += 38; /* 多添加一点，因为tab型 布局变了 */
    
    this.collapsedMaxHeight = totalHeight;
  }
  
  toggleExpandCollapse() {
    if (this.isExpanded) {
      this.collapse();
    } else {
      this.expand();
    }
  }
  
  collapse() {
    this.isExpanded = false;
    this.classList.remove('expanded');
    
    // 设置最大高度为前3个产品的高度
    if (this.collapsedMaxHeight) {
      this.style.maxHeight = this.collapsedMaxHeight + 'px';
      this.style.overflow = 'hidden';
    }
  }
  
  expand() {
    this.isExpanded = true;
    this.classList.add('expanded');
    
    // 移除高度限制
    this.style.maxHeight = 'none';
    this.style.overflow = 'hidden auto';
  }
  
  setupProductItem(item) {
    const selectBtn = item.querySelector('.product-select-btn');
    const variantSelect = item.querySelector('.variant-select');
    
    // 为整个产品项绑定点击事件
    item.addEventListener('click', (e) => {
      // 阻止点击选框和变体选择器时的默认行为
      if (e.target.closest('.product-select-btn') || e.target.closest('.variant-select')) {
        return;
      }
      this.toggleProductSelection(item);
    });

    // 为选择按钮绑定点击事件
    if (selectBtn) {
      selectBtn.addEventListener('click', (e) => {
        e.stopPropagation(); // 阻止冒泡到父元素
        this.toggleProductSelection(item);
      });
    }

    // 为变体选择器绑定变更事件
    if (variantSelect) {
      variantSelect.addEventListener('change', (e) => {
        e.stopPropagation(); // 阻止冒泡到父元素
        this.handleVariantChange(item, e.target);
      });
    }
  }

  toggleProductSelection(item) {
    const productData = this.getProductData(item);
    const isSelected = item.classList.contains('selected');

    if (isSelected) {
      // 取消选中
      item.classList.remove('selected');
      this.selectedProducts.delete(productData.id);
      this.updateSelectButton(item, false);
    } else {
      // 单选模式：选中新产品前，先取消选中当前tab下的所有其他产品
      if (this.singleSelectMode) {
        this.querySelectorAll('.new-additional-product-item.selected').forEach(selectedItem => {
          const selectedProductData = this.getProductData(selectedItem);
          selectedItem.classList.remove('selected');
          this.selectedProducts.delete(selectedProductData.id);
          this.updateSelectButton(selectedItem, false);
        });
      }
      // 选中
      item.classList.add('selected');
      this.selectedProducts.add(productData.id);
      this.updateSelectButton(item, true);
    }

    // 触发自定义事件，通知其他组件
    this.dispatchEvent(new CustomEvent('selection-changed', {
      detail: {
        productId: productData.id,
        selected: !isSelected,
        selectedProducts: Array.from(this.selectedProducts)
      }
    }));

    // 重新检查是否需要显示渐变效果(表达可以往下滚动)
    setTimeout(() => {
      this.checkOverflowAndGradient();
    }, 0);
  }

  updateSelectButton(item, isSelected) {
    const unselectedIcon = item.querySelector('.unselected-icon');
    const selectedIcon = item.querySelector('.selected-icon');
    
    if (isSelected) {
      unselectedIcon.style.display = 'none';
      selectedIcon.style.display = 'block';
    } else {
      unselectedIcon.style.display = 'flex';
      selectedIcon.style.display = 'none';
    }
  }

  handleVariantChange(item, selectElement) {
    const selectedOption = selectElement.options[selectElement.selectedIndex];
    const productData = this.getProductData(item);
    
    // 获取变体数据
    const variantData = {
      id: selectedOption.value,
      price: selectedOption.dataset.price,
      comparePrice: selectedOption.dataset.comparePrice,
      image: selectedOption.dataset.image
    };

    // 更新产品显示信息
    this.updateProductDisplay(item, variantData, productData);
    
    // 触发变体变化事件，通知价格计算逻辑
    this.dispatchEvent(new CustomEvent('variant-changed', {
      detail: {
        productId: productData.id,
        variantId: variantData.id,
        variantData: variantData
      }
    }));
  }

  updateProductDisplay(item, variantData, productData) {
    // 更新图片
    const productImage = item.querySelector('.product-image img');
    if (productImage && variantData.image) {
      productImage.src = variantData.image;
    }

    // 更新价格
    const currentPriceElement = item.querySelector('.current-price');
    const comparePriceElement = item.querySelector('.compare-price');
    
    if (currentPriceElement) {
      const formattedPrice = this.formatPrice(variantData.price);
      currentPriceElement.textContent = `$${formattedPrice}`;
    }

    if (comparePriceElement) {
      const comparePrice = variantData.comparePrice;
      const price = variantData.price;
      
      // 检查 comparePrice 是否有效（不为 null、"null"、undefined 或空字符串）
      if (comparePrice && 
          comparePrice !== "null" && 
          comparePrice !== "" && 
          comparePrice !== null && 
          comparePrice !== "0" &&
          parseFloat(comparePrice) > 0 &&
          parseFloat(comparePrice) > parseFloat(price)) {
        const formattedComparePrice = this.formatPrice(comparePrice);
        comparePriceElement.textContent = `$${formattedComparePrice}`;
        comparePriceElement.style.display = 'inline';
      } else {
        comparePriceElement.style.display = 'none';
      }
    }
  }

  getProductData(item) {
    const dataScript = item.querySelector('.product-data');
    if (dataScript) {
      try {
        return JSON.parse(dataScript.textContent);
      } catch (e) {
        console.error('Error parsing product data:', e);
        return {};
      }
    }
    return {};
  }

  formatPrice(priceInCents) {
    return (parseFloat(priceInCents) / 100).toFixed(2);
  }

  // 检查是否需要显示渐变效果
  checkOverflowAndGradient() {
    const productsContainer = this.querySelector('.new-additional-products');
    if (!productsContainer) return;

    // 检查内容是否产生滚动
    const scrollHeight = productsContainer.scrollHeight;
    const clientHeight = productsContainer.clientHeight;
    const hasVerticalScroll = scrollHeight > clientHeight;
    
    if (hasVerticalScroll) {
      this.classList.add('show-gradient');
    } else {
      this.classList.remove('show-gradient');
    }
  }

  // 获取所有选中的产品信息
  getSelectedProducts() {
    const selectedItems = this.querySelectorAll('.new-additional-product-item.selected');
    return Array.from(selectedItems).map(item => {
      const productData = this.getProductData(item);
      const variantSelector = item.querySelector('.product-variant-selector');
      const variantSelect = (variantSelector && variantSelector.classList.contains('hidden')) ? null : item.querySelector('.variant-select');
      const selectedVariantId = variantSelect ? variantSelect.value : null;
      
      return {
        productId: productData.id,
        variantId: selectedVariantId,
        productData: productData
      };
    });
  }
}

// 注册自定义元素
if (!window.customElements.get('tab-additional-products')) {
  customElements.define('tab-additional-products', TabAdditionalProducts);
}

// 倒计时 + 优惠券复制 分区（sections/coupons-with-countdown.liquid）
class CountdownCouponsSection extends HTMLElement {
  constructor() {
    super();
    this._tick = this._tick.bind(this);
    this._handleCopyClick = this._handleCopyClick.bind(this);
  }
  connectedCallback() {
    this.sectionId = this.getAttribute('data-section-id') || '';
    this.expireAtStr = (this.getAttribute('data-expire-at') || '').trim();

    // 倒计时节点
    this.daysEl = this.querySelector('[data-time="days"]');
    this.hoursEl = this.querySelector('[data-time="hours"]');
    this.minutesEl = this.querySelector('[data-time="minutes"]');
    this.secondsEl = this.querySelector('[data-time="seconds"]');
    this.daysItem = this.querySelector('[data-days-item]');
    this.hoursItem = this.querySelector('[data-hours-item]');
    this.colons = this.querySelectorAll('.ccs__timer-colon');

    // 初始化倒计时（本地存储一个结束时间，避免刷新立刻重置）
    this._initCountdown();

    // 绑定复制按钮并记录初始文案
    this.querySelectorAll('.ccs__copy-btn').forEach((btn) => {
      if (!btn.dataset.btnOriginal) {
        btn.dataset.btnOriginal = (btn.textContent || '').trim();
      }
      btn.addEventListener('click', this._handleCopyClick);
    });
  }
  disconnectedCallback() {
    if (this._timer) {
      clearInterval(this._timer);
      this._timer = null;
    }
    this.querySelectorAll('.ccs__copy-btn').forEach((btn) => {
      btn.removeEventListener('click', this._handleCopyClick);
      if (btn._ccsRevertTimer) {
        clearTimeout(btn._ccsRevertTimer);
        btn._ccsRevertTimer = null;
      }
    });
  }
  _initCountdown() {
    // 无有效到期时间则不计时（不做格式判断，仅判断是否存在）
    if (!this.expireAtStr) return;
    this._endTime = this._parseExpireAt(this.expireAtStr).getTime();
    this._tick();
    this._timer = setInterval(this._tick, 1000);
  }
  _tick() {
    if (!this._endTime) return;
    const now = Date.now();
    let diff = Math.max(0, this._endTime - now);

    const totalSeconds = Math.floor(diff / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    if (this.daysEl) this.daysEl.textContent = String(days).padStart(2, '0');
    if (this.hoursEl) this.hoursEl.textContent = String(hours).padStart(2, '0');
    if (this.minutesEl) this.minutesEl.textContent = String(minutes).padStart(2, '0');
    if (this.secondsEl) this.secondsEl.textContent = String(seconds).padStart(2, '0');

    // 动态隐藏 Days / Hours：当 Days>0 时，Hours 也应该展示（即便为 00）
    // Minutes / Seconds 永远显示
    const showDays = days > 0;
    const showHours = showDays || hours > 0;
    if (this.daysItem) this.daysItem.style.display = showDays ? '' : 'none';
    if (this.hoursItem) this.hoursItem.style.display = showHours ? '' : 'none';
    if (this.colons && this.colons.length) {
      const colonAfterDays = this.colons[0];
      const colonAfterHours = this.colons[1];
      if (colonAfterDays) colonAfterDays.style.display = showDays ? '' : 'none';
      if (colonAfterHours) colonAfterHours.style.display = (showDays || showHours) ? '' : 'none';
    }

    if (totalSeconds <= 0 && this._timer) {
      clearInterval(this._timer);
      this._timer = null;
    }
  }
  _parseExpireAt(str) {
    // 格式保证为 yyyy-MM-dd HH:mm:ss，直接转为 ISO 本地时间格式
    return new Date(String(str).replace(' ', 'T'));
  }
  async _handleCopyClick(event) {
    const btn = event.currentTarget;
    if (btn.disabled || btn.classList.contains('is-disabled')) return;
    const wrapper = btn.closest('.ccs__card');
    if (!wrapper) return;

    const code = btn.getAttribute('data-clipboard') || '';
    const afterText = (btn.getAttribute('data-after-text') || '').trim();
    const btnAfterText = (btn.getAttribute('data-btn-after-text') || '').trim();

    try {
      await this._copyToClipboard(code);
    } catch (e) {
      // 忽略错误，仍然进行 UI 更新
    }

    // 替换左侧文本
    const beforeEl = wrapper.querySelector('.ccs__discount--before');
    const afterEl = wrapper.querySelector('.ccs__discount--after');
    if (afterText && beforeEl && afterEl) {
      beforeEl.hidden = true;
      afterEl.hidden = false;
      afterEl.textContent = afterText;
    }

    // 按钮文本替换，并在2秒后恢复
    if (btnAfterText) {
      btn.textContent = btnAfterText;
      const originalText = (btn.dataset.btnOriginal || '').trim();
      if (originalText) {
        if (btn._ccsRevertTimer) clearTimeout(btn._ccsRevertTimer);
        btn._ccsRevertTimer = setTimeout(() => {
          btn.textContent = originalText;
          btn._ccsRevertTimer = null;
        }, 2000);
      }
    }
  }
  _copyToClipboard(text) {
    // 优先使用现代 API
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }
    // 兼容处理（参考 coupon.liquid 思路）
    return new Promise((resolve, reject) => {
      try {
        const ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.position = 'absolute';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        const ok = document.execCommand('copy');
        document.body.removeChild(ta);
        ok ? resolve() : reject(new Error('execCommand copy failed'));
      } catch (err) {
        reject(err);
      }
    });
  }
}

if (!window.customElements.get('countdown-coupons-section')) {
  customElements.define('countdown-coupons-section', CountdownCouponsSection);
}


// 自定义：折扣码复制横幅
class DiscountCodeBanner extends HTMLElement {
  constructor() {
    super();
    this._copyBtn = null;
    this._handleCopy = this._handleCopy.bind(this);
  }

  connectedCallback() {
    this._copyBtn = this.querySelector('.discount-banner__copy-btn');
    if (this._copyBtn) {
      this._copyBtn.addEventListener('click', this._handleCopy);
    }
  }

  disconnectedCallback() {
    if (this._copyBtn) {
      this._copyBtn.removeEventListener('click', this._handleCopy);
    }
  }

  async _handleCopy(event) {
    const btn = event.currentTarget;
    const discountCode = btn.getAttribute('data-discount-code');
    
    if (!discountCode) return;

    try {
      // 尝试使用现代 Clipboard API
      await navigator.clipboard.writeText(discountCode);
      this._showCopiedState(btn);
    } catch (err) {
      // 降级方案：使用 textarea 方法
      this._fallbackCopy(discountCode, btn);
    }
  }

  _fallbackCopy(text, btn) {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    try {
      const successful = document.execCommand('copy');
      if (successful) {
        this._showCopiedState(btn);
      } else {
        console.error('Copy command failed');
      }
    } catch (err) {
      console.error('Failed to copy:', err);
    }
    
    document.body.removeChild(textArea);
  }

  _showCopiedState(btn) {
    // 添加 copied 状态
    btn.classList.add('copied');
    
    // 2.5秒后移除 copied 状态
    setTimeout(() => {
      btn.classList.remove('copied');
    }, 2500);
  }
}

if (!window.customElements.get('discount-code-banner')) {
  customElements.define('discount-code-banner', DiscountCodeBanner);
}

class OfpPrice extends HTMLElement {
  constructor() {
    super();
    this._onScroll = this._onScroll.bind(this);
    this._modalCalled = false;
    this._onGlobalBeginCountdown = this._onGlobalBeginCountdown.bind(this);
    this._countdownRAF = null;
    this._countdownEndTime = null;
    this._hasTriggeredModal = 0;
  }
  connectedCallback() {
    this._cacheEls();

    this._installments = parseInt(this.getAttribute('data-installments')) || 0;
    this._price = this._safeParseMoney(this.getAttribute('data-price'));
    this._comparePrice = this._safeParseMoney(this.getAttribute('data-compare-price'));
    this._savings = this._safeParseMoney(this.getAttribute('data-savings')) || 0;
    this._countdownMinutes = parseInt(this.getAttribute('data-countdown-minutes')) || 0;
    this._countdownLabel = this.getAttribute('data-countdown-label') || '';

    // 从 Local Storage 读取 modal 触发状态
    const productHandle = this._getProductHandle();
    if (productHandle) {
      const storageKey = productHandle + ' hasTriggeredModal';
      try {
        const storedValue = localStorage.getItem(storageKey);
        if (storedValue !== null) {
          this._hasTriggeredModal = parseInt(storedValue) || 0;
        }
      } catch (e) {
        console.error('Failed to read from localStorage:', e);
      }
    }
    
    this.addEventListener('ofp:switch-to-final', () => this._switchToFinal());
    this.addEventListener('ofp:begin-countdown', (e) => this.beginCountdown((e && e.detail) || {}));
    document.addEventListener('ofp:begin-countdown', this._onGlobalBeginCountdown);

    window.addEventListener('scroll', this._onScroll, { passive: true });
    window.addEventListener('resize', this._onScroll);
    setTimeout(this._onScroll, 0);

    // 如果全局已经有倒计时结束时间（说明切换变体后重新挂载），则恢复倒计时
    if (window.__ofpCountdownGlobal && typeof window.__ofpCountdownGlobal.endTime === 'number') {
      const globalCfg = window.__ofpCountdownGlobal;
      const now = Date.now();
      const remainMs = Math.max(0, globalCfg.endTime - now);
      if (remainMs > 0) {
        const remainMinutes = remainMs / 1000 / 60;
        this.countdownContainerEl && this.countdownContainerEl.classList.remove('hidden');
        this.beginCountdown({
          minutes: remainMinutes,
          label: globalCfg.label,
          sectionId: globalCfg.sectionId,
        });
      }
    }
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this._onScroll);
    window.removeEventListener('resize', this._onScroll);
    document.removeEventListener('ofp:begin-countdown', this._onGlobalBeginCountdown);
    if (this._countdownRAF) {
      cancelAnimationFrame(this._countdownRAF);
      this._countdownRAF = null;
    }
  }

  triggerModal() {
    const event = new CustomEvent("open-coupon-modal");
    const modal = document.querySelector('script-trigger-modal[listen-event="open-coupon-modal"]');
    modal.dispatchEvent(event);
    
    // 保存到 Local Storage
    const productHandle = this._getProductHandle();
    if (productHandle) {
      const storageKey = productHandle + ' hasTriggeredModal';
      try {
        localStorage.setItem(storageKey, '1');
        this._hasTriggeredModal = 1;
      } catch (e) {
        console.error('Failed to write to localStorage:', e);
      }
    }
  }

  _getProductHandle() {
    // 从 URL 中提取 product handle
    // 例如: http://127.5.3.5:9292/products/deerrun-plus-walkingpad-treadmill
    // 返回: deerrun-plus-walkingpad-treadmill
    const pathParts = window.location.pathname.split('/');
    const productsIndex = pathParts.indexOf('products');
    if (productsIndex !== -1 && pathParts.length > productsIndex + 1) {
      return pathParts[productsIndex + 1];
    }
    return null;
  }

  _cacheEls() {
    this.currentPriceEl = this.querySelector('.current-price');
    this.compareAtEl = this.querySelector('.compare-at-price');
    this.badgeEl = this.querySelector('.new-price-badge');
    this.installmentEl = this.querySelector('.installment-price');
    this.countdownLabelEl = this.querySelector('.countdown-label');
    this.countdownTimerEl = this.querySelector('.countdown-timer');
    this.countdownContainerEl = this.querySelector('.offer-countdown');
  }

  beginCountdown(options = {}) {
    if (!this.countdownTimerEl) return;
    
    // 获取倒计时分钟数和标签
    const minutes = typeof options.minutes === 'number' ? options.minutes : (parseInt(this._countdownMinutes) || 0);
    const label = options.label != null ? String(options.label) : (this._countdownLabel || '');
    
    // 设置标签文本
    if (this.countdownLabelEl && label) {
      this.countdownLabelEl.textContent = label;
    }
    
    // 如果分钟数无效，显示 00:00:00
    if (!minutes || minutes <= 0) {
      this.countdownTimerEl.textContent = '00 : 00 : 00';
      return;
    }
    
    // 清除旧的倒计时
    if (this._countdownRAF) {
      cancelAnimationFrame(this._countdownRAF);
      this._countdownRAF = null;
    }

    // 计算结束时间（如果外部已经给了 endTime，则优先使用）
    if (typeof options.endTime === 'number') {
      this._countdownEndTime = options.endTime;
    } else {
      this._countdownEndTime = Date.now() + minutes * 60 * 1000;
    }

    // 将当前倒计时状态保存到全局，方便变体切换后恢复
    try {
      const sectionId = this.getAttribute('data-section-id') || (options && options.sectionId) || null;
      window.__ofpCountdownGlobal = {
        endTime: this._countdownEndTime,
        label,
        sectionId,
      };
    } catch (e) {}

    // 补零函数
    const pad = (n) => String(n).padStart(2, '0');
    
    // 更新倒计时显示
    const updateCountdown = () => {
      const remainMs = Math.max(0, this._countdownEndTime - Date.now());

      const totalSec = Math.floor(remainMs / 1000);
      
      const hours = Math.floor(totalSec / 3600);
      const minutes = Math.floor((totalSec % 3600) / 60);
      const seconds = totalSec % 60;
      
      this.countdownTimerEl.textContent = `${pad(hours)} : ${pad(minutes)} : ${pad(seconds)}`;
      
      // 如果倒计时未结束，继续下一帧
      if (remainMs > 0) {
        this._countdownRAF = requestAnimationFrame(updateCountdown);
      } else {
        this._countdownRAF = null;
        // 倒计时结束，隐藏倒计时容器
        if (this.countdownContainerEl) {
          this.countdownContainerEl.classList.add('hidden');
        }
      }
    };
    
    // 立即执行一次并开始循环
    updateCountdown();
  }

  _onGlobalBeginCountdown(e) {
    const detail = (e && e.detail) || {};
    const sectionId = this.getAttribute('data-section-id');
    if (!detail.sectionId || detail.sectionId === sectionId) {
      this.countdownContainerEl.classList.remove('hidden');
      this.beginCountdown(detail);
    }
  }
  _onScroll() {
    if (this._modalCalled || !this.currentPriceEl) return;
    const rect = this.currentPriceEl.getBoundingClientRect();
    const centerY = window.innerHeight / 2;
    const centerVisible = rect.top - 100 <= centerY;
    if(this._hasTriggeredModal === 0) { // 因为centerVisible值不稳定，所以不能&&一起判断
      if (centerVisible) {
        this._modalCalled = true;
        try { this.triggerModal(); } catch (e) {}
      }
    } else {
      this._switchToFinal();
    }
  }
  _switchToFinal() {
    if (!this.currentPriceEl) return;
    const fromCurrent = this._getDisplayedNumber(this.currentPriceEl);
    if (this._price != null) {
      this._animateMoney(this.currentPriceEl, fromCurrent, this._price, { prefix: '£' });
    }
    if (this.compareAtEl) {
      this.compareAtEl.classList.remove('hidden');
    }
    if (this.badgeEl) {
      const badgeFrom = this._extractNumberFromText(this.badgeEl.textContent);
      this.badgeEl.style.marginTop = '0px';
      this._animateMoney(this.badgeEl, badgeFrom, this._savings, { prefix: '£', suffix: ' OFF', decimals: 0 });
    }
    if (this.installmentEl) {
      const fromInstallment = this._getDisplayedNumber(this.installmentEl);
      const targetInstallment = (this._installments > 0 && this._price != null)
        ? Math.round((this._price * 100) / this._installments) / 100
        : (this._price != null ? this._price : fromInstallment);
      const hasMo = /\/mo\b/.test(this.installmentEl.textContent);
      this._animateMoney(this.installmentEl, fromInstallment, targetInstallment, { prefix: '£', suffix: hasMo ? '/mo' : '' });
    }
  }
  _safeParseMoney(val) {
    if (val == null || val === '' || val === 'null' || val === 'undefined') return null;
    const num = parseFloat(val);
    if (isNaN(num)) return null;
    return num / 100;
  }
  _getDisplayedNumber(el) {
    const text = (el && el.textContent ? el.textContent : '').replace(/[^\d.,-]/g, '').replace(/,/g, '');
    const n = parseFloat(text);
    return isNaN(n) ? 0 : n;
  }
  _extractNumberFromText(text) {
    if (!text) return 0;
    const t = String(text).replace(/[^\d.,-]/g, '').replace(/,/g, '');
    const n = parseFloat(t);
    return isNaN(n) ? 0 : n;
  }
  _formatMoney(val, decimals = 2) {
    const n = typeof val === 'number' ? val : parseFloat(val) || 0;
    return n.toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
  }
  _animateMoney(el, from, to, opts = {}) {
    const prefix = opts.prefix || '';
    const suffix = opts.suffix || '';
    const decimals = Number.isInteger(opts.decimals) ? opts.decimals : 2;
    if (!window.matchMedia || !window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
      el.textContent = prefix + this._formatMoney(to, decimals) + suffix;
      return;
    }
    const start = performance.now();
    const duration = 700;
    const animate = (now) => {
      const p = Math.min(1, (now - start) / duration);
      const val = from + (to - from) * p;
      el.textContent = prefix + this._formatMoney(val, decimals) + suffix;
      if (p < 1) requestAnimationFrame(animate);
    };
    requestAnimationFrame(animate);
  }
}

if (!window.customElements.get('ofp-price')) {
  customElements.define('ofp-price', OfpPrice);
}

// 顶部固定锚点条 - 单个锚点项
//! 该功能，需要注意的是稳定性处理，避免：运营填入的单个信息错误，执行代码报错，继而导致整个锚点条top值未设置上。
class HeaderAnchorItem extends HTMLElement {
  constructor() {
    super();
    this.selectorStr = this.getAttribute("selector-str");
    this.nthDom = parseInt(this.getAttribute("nth-dom")) || 1;
    this.rewriteId = this.getAttribute("rewrite-id");
    this.headerAnchorContainer = this.closest('header-anchor-container');
    this.targetDom = null; // 目标dom元素
    this.targetDomIdAttr = ""; // 目标dom元素的id值
  }
  connectedCallback() {
    this.init();
  }
  init() {
    this.targetDom = this.getTargetDom();
    if (!this.targetDom) {
      return;
    }
    
    if (this.rewriteId) {
      this.rewriteDomId();
    }
    
    // 获取并存储目标DOM的id属性值
    this.targetDomIdAttr = this.targetDom.getAttribute("id") || "";
    
    this.rewriteAEle();
    // this.setupClickListener(); 不需要设置什么点击事件，直接a标签转跳之后，交由滚动锁定来做。
  }

  getTargetDom() {
    try {
      if (this.nthDom - 1 < 0) return null;
      
      // 分两步处理：先查询所有元素，再获取指定索引的元素
      const allElements = document.querySelectorAll(`${this.selectorStr}`);
      if (!allElements || allElements.length === 0) return null;
      
      const targetDom = allElements[this.nthDom - 1];
      return targetDom || null;
    } catch (error) {
      console.error('Error in getTargetDom:', error);
      return null;
    }
  }

  rewriteDomId() {
    this.targetDom.setAttribute('id', this.rewriteId);
  }

  rewriteAEle() {
    const aEle = this.querySelector("a");
    const targetDomId = this.targetDom.getAttribute("id");
    if (!aEle || !targetDomId) {
      return;
    }
    aEle.setAttribute("href", `#${targetDomId}`);
  }

  setupClickListener() {
    const aEle = this.querySelector("a");
    if (!aEle) return;

    aEle.addEventListener('click', (e) => {
      // 移除所有锚点的激活态
      if (this.headerAnchorContainer) {
        const allLinks = this.headerAnchorContainer.querySelectorAll('.header-anchor-item');
        allLinks.forEach(link => link.classList.remove('active'));
      }
      if (this.targetDomIdAttr) { //目标dom元素必须要有id，我才给它激活态
        // 为当前点击的锚点添加激活态
        this.classList.add('active');
      }
    });
  }
}

if (!window.customElements.get("header-anchor-item")) {
  customElements.define("header-anchor-item", HeaderAnchorItem);
}

// 顶部固定锚点条 - 容器（负责滚动追踪和固定定位）
//! 该功能，需要注意的是稳定性处理，避免：运营填入的单个信息错误，执行代码报错，继而导致整个锚点条top值未设置上。
class HeaderAnchorContainer extends HTMLElement {
  constructor() {
    super();
    this.hadFixedTopClassArr = this.getAttribute("had-fixed-top-class-arr");
    this.dynamicFixedTopSelectorArr = this.getAttribute("dynamic-fixed-top-selector-arr");
    this.observer = null;
  }
  connectedCallback() {
    this.init();
  }
  init() {
    this.setupScrollTracking();
    this.setFixedTopPosition();
    this.setupDynamicElementObserver();
  }
  
  /* 监听动态插件元素的出现，并重新计算top值 */
  setupDynamicElementObserver() {
    if (!this.dynamicFixedTopSelectorArr) return;
    
    const selectorArr = this.dynamicFixedTopSelectorArr.split(',').map(s => s.trim()).filter(Boolean);
    if (selectorArr.length === 0) return;
    
    // 使用MutationObserver监听DOM变化
    this.observer = new MutationObserver(() => {
      // 检查是否有配置的动态元素出现
      const hasDynamicElements = selectorArr.some(selector => {
        return document.querySelector(selector) !== null;
      });
      
      if (hasDynamicElements) {
        // 重新计算top值
        this.setFixedTopPosition();
      }
    });
    
    // 开始观察整个document的子树变化
    this.observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    // 初始检查一次
    setTimeout(() => {
      const hasDynamicElements = selectorArr.some(selector => {
        return document.querySelector(selector) !== null;
      });
      if (hasDynamicElements) {
        this.setFixedTopPosition();
      }
    }, 500);
  }
  
  disconnectedCallback() {
    // 清理observer
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  /* 设置滚动追踪(当滚动到某个section时，对应的锚点项会高亮) */
  setupScrollTracking() {
    const allItems = Array.from(this.querySelectorAll('header-anchor-item'));
    
    // 获取所有目标元素
    const targetElements = allItems.map(item => {
      try {
        const selectorStr = item.getAttribute("selector-str");
        const nthDom = parseInt(item.getAttribute("nth-dom")) || 1;
        const elements = document.querySelectorAll(selectorStr);
        return elements[nthDom - 1];
      } catch (error) {
        console.error('Error querying selector in setupScrollTracking:', error);
        return null;
      }
    }).filter(Boolean);

    const calculateActive = () => {
      const viewportHeight = window.innerHeight;
      // 屏幕底部上方30%的位置
      const triggerPoint = viewportHeight * 0.6; // 底部上方30% = 从顶部算70%
      
      let currentId = '';
      
      // 找到当前滚动位置对应的section
      // 从后往前遍历，找到第一个顶部位置在触发点之上的元素
      for (let i = targetElements.length - 1; i >= 0; i--) {
        const element = targetElements[i];
        const rect = element.getBoundingClientRect();
        const elementTop = rect.top;
        
        // 如果元素顶部已经到达或超过触发点（在触发点上方）
        if (elementTop <= triggerPoint) {
          currentId = element.getAttribute('id');
          break;
        }
      }

      // 更新所有链接的active状态
      allItems.forEach((item) => {
        item.classList.remove('active');
        if (item.querySelector('a')?.getAttribute('href')?.substring(1) === currentId) {
          item.classList.add('active');
        }
      });
    };

    window.addEventListener('scroll', calculateActive);
    calculateActive();
  }

  setFixedTopPosition() {
    const section = this.closest('[id^="shopify-section-"]');
    if (!section) return;

    let topValue = 0;
    
    // 计算hadFixedTopClassArr的高度
    if (this.hadFixedTopClassArr) {
      const classArr = this.hadFixedTopClassArr.split(',').map(c => c.trim()).filter(Boolean);
      topValue += classArr.reduce((prev, item) => {
        let height = 0;
        const element = document.querySelector(item);
        if (element) {
          height = element.clientHeight;
        }
        return prev + height;
      }, 0);
    }
    
    // 计算dynamicFixedTopSelectorArr的高度
    if (this.dynamicFixedTopSelectorArr) {
      const dynamicArr = this.dynamicFixedTopSelectorArr.split(',').map(s => s.trim()).filter(Boolean);
      topValue += dynamicArr.reduce((prev, selector) => {
        let height = 0;
        const element = document.querySelector(selector);
        if (element) {
          height = element.clientHeight;
        }
        return prev + height;
      }, 0);
    }

    section.style.top = topValue + 'px';
  }
}

if (!window.customElements.get("header-anchor-container")) {
  customElements.define("header-anchor-container", HeaderAnchorContainer);
}

// Custom: Tab Product Showcase Logic
class ProductTabs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.tabs = this.querySelectorAll('.tab-nav-item');
    this.panels = this.querySelectorAll('.tab-panel');

    this.tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        // Remove active class from all
        this.tabs.forEach(t => t.classList.remove('active'));
        this.panels.forEach(p => p.classList.remove('active'));

        // Add active to clicked
        tab.classList.add('active');
        const targetId = tab.getAttribute('data-tab-target');
        const targetPanel = document.getElementById(targetId);
        if (targetPanel) {
            targetPanel.classList.add('active');
            // Trigger resize event to ensure scroll area recalculates if needed
            window.dispatchEvent(new Event('resize'));
        }
      });
    });
  }
}

if (!window.customElements.get("product-tabs")) {
  customElements.define("product-tabs", ProductTabs);
}

class AnimationText extends HTMLElement {
  constructor() {
    super();
    this.from = 0; // 默认起始值
    this.currentValue = 0;
    this.hasAnimated = false; // 跟踪动画是否已经播放过
    this.observer = null;
    this.originalText = ''; // 存储原始文本以分析格式
    this.decimalPlaces = 0; // 存储小数位数
  }

  connectedCallback() {
    // 保存原始文本
    this.originalText = this.textContent.trim();
    
    // 获取目标值
    this.to = parseFloat(this.originalText);

    if (isNaN(this.to)) {
      return;
    }

    this.duration = parseFloat(this.getAttribute('duration')) || 1.0;
    
    // 设置起始值（从0开始或者目标值的一小部分）
    this.from = this.to > 100 ? this.to * 0.5 : 0;
    
    // 分析原始数字的小数位数
    this.analyzeDecimalPlaces();
    
    // 初始显示起始值
    this.updateNumber(this.from);
    
    // 使用 IntersectionObserver 监视元素是否进入视口
    this.setupIntersectionObserver();
  }

  // 分析原始数字的小数位数
  analyzeDecimalPlaces() {
    const parts = this.originalText.split('.');
    if (parts.length > 1) {
      this.decimalPlaces = parts[1].length;
    } else {
      this.decimalPlaces = 0;
    }
  }

  setupIntersectionObserver() {
    this.observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      
      // 当元素进入视口且动画尚未播放时开始动画
      if (entry.isIntersecting && !this.hasAnimated) {
        setTimeout(() => {
          this.animateNumberChange(this.from, this.to);
          this.hasAnimated = true;
        }, 600);
      }
    }, {
      threshold: 0.1 // 当元素有10%进入视口时触发
    });
    
    this.observer.observe(this);
  }

  // 缓动函数 - 指数减速
  easeOutExpo(x) {
    return x === 1 ? 1 : 1 - Math.pow(2, -10 * x);
  }

  // 更新显示的数字，保持与原始输入相同的小数位数
  updateNumber(value) {
    this.currentValue = value;
    // 使用分析出的小数位数格式化数字
    this.textContent = value.toFixed(this.decimalPlaces);
  }

  async animateNumberChange(from, to) {
    if (!window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
      // 如果用户偏好减少动画，则直接显示最终结果而不进行动画
      this.updateNumber(to);
      return;
    }
    
    const duration = this.duration; // 动画持续时间，单位秒
    const startTime = performance.now();
    
    const animate = (currentTime) => {
      const elapsed = (currentTime - startTime) / 1000; // 转换为秒
      const progress = Math.min(elapsed / duration, 1);
      const easedProgress = this.easeOutExpo(progress);
      const currentValue = from + (to - from) * easedProgress;
      
      this.updateNumber(currentValue);
      
      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };
    
    requestAnimationFrame(animate);
  }

  disconnectedCallback() {
    // 清理观察器以防止内存泄漏
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
}

// 注册自定义元素
if (!window.customElements.get("animation-text")) {
  customElements.define("animation-text", AnimationText);
}

class ProductFilterSection extends HTMLElement {
  constructor() {
    super();
    this.products = [];
    this.config = {};
    this.activeFilters = {}; 
  }

  connectedCallback() {
    // 1. 初始化数据
    try {
      const dataScript = this.querySelector('#product-data-pool');
      const configScript = this.querySelector('#config-data');
      if (dataScript) this.products = JSON.parse(dataScript.textContent);
      if (configScript) this.config = JSON.parse(configScript.textContent);

      // 解析优先展示标签配置
      this.priorityTags = [];
      if (this.config.priority_tags) {
        this.priorityTags = this.config.priority_tags.split(',').map(t => t.trim()).filter(Boolean);
      }
      
      // 数据预处理（variant级别）
      // filter_show: 分号分隔，既用于筛选也用于显示
      // filter_hide: 分号分隔，只用于筛选不显示
      this.products = this.products.map(v => {
          // 解析filter_show（显示+筛选）
          let showTags = [];
          if (v.filter_show) {
              v.filter_show.split(';').forEach(t => {
                  const trimmed = t.trim();
                  if (trimmed) showTags.push(trimmed);
              });
          }

          // 解析filter_hide（仅筛选）
          let hideTags = [];
          if (v.filter_hide) {
              v.filter_hide.split(';').forEach(t => {
                  const trimmed = t.trim();
                  if (trimmed) hideTags.push(trimmed);
              });
          }

          // display_tags: 只包含filter_show的标签
          v.display_tags = [...new Set(showTags)];
          // filter_tags: 包含filter_show和filter_hide的所有标签
          v.filter_tags = [...new Set([...showTags, ...hideTags])];

          v.quote = v.quote || "";
          return v;
      });

    } catch (e) {
      console.error('Error parsing product data:', e);
    }

    this.resultsContainer = this.querySelector('[id^="filter-results-"]');
    this.initEventListeners();
    
    // 2. 检查 URL 参数
    this.checkUrlParams();
  }

  checkUrlParams() {
    const params = new URLSearchParams(window.location.search);
    const filtersParam = params.get('filters');

    if (filtersParam) {
      // --- 现有逻辑：如果有 URL 参数 ---
      const tagsToSelect = filtersParam.split(',').map(tag => decodeURIComponent(tag.trim()));
      const allButtons = this.querySelectorAll('.filter-btn');
      let hasChanges = false;

      allButtons.forEach(btn => {
        const btnValue = btn.dataset.value;
        const groupDiv = btn.closest('.tag-group');
        const groupId = groupDiv.dataset.groupId;

        if (tagsToSelect.includes(btnValue)) {
          // 清除同组其他高亮
          groupDiv.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
          // 激活当前
          btn.classList.add('active');
          this.activeFilters[groupId] = btnValue;
          hasChanges = true;
        }
      });

      if (hasChanges) {
        this.filterAndSortProducts();
      } else {
        // 如果参数有误没匹配到任何按钮，展示默认前6个（无筛选项时显示6个）
        this.renderProducts(this.products.slice(0, 6));
      }
    } else {
      const defaultTagsRaw = this.dataset.defaultTags || this.getAttribute('data-default-tags') || '';
      const defaultTags = defaultTagsRaw
        .split(',')
        .map(t => t.trim())
        .filter(Boolean);

      const escapeCssValue = (value) => {
        if (window.CSS && typeof window.CSS.escape === 'function') {
          return window.CSS.escape(value);
        }
        return String(value).replace(/[^a-zA-Z0-9_\u00A0-\uFFFF-]/g, (ch) => `\\${ch}`);
      };

      defaultTags.forEach((defaultTag) => {
        const defaultBtn = this.querySelector(`.filter-btn[data-value="${escapeCssValue(defaultTag)}"]`);

        if (!defaultBtn) return;

        const groupDiv = defaultBtn.closest('.tag-group');
        if (!groupDiv) return;

        const groupId = groupDiv.dataset.groupId;

        // 同组只允许一个选中：清除同组其他
        groupDiv.querySelectorAll('.filter-btn').forEach(b => {
          b.classList.remove('active');
        });

        defaultBtn.classList.add('active');
        this.activeFilters[groupId] = defaultTag;
      });

      // 无论是否匹配到按钮，都走统一的渲染逻辑
      // - 匹配到了：会按默认选中标签进行筛选
      // - 没匹配到/没配置：展示默认结果
      this.filterAndSortProducts();
    }
  }

  initEventListeners() {
    const buttons = this.querySelectorAll('.filter-btn');
    buttons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        this.handleFilterClick(e.currentTarget);
      });
    });
  }

  handleFilterClick(clickedBtn) {
    const groupDiv = clickedBtn.closest('.tag-group');
    const groupId = groupDiv.dataset.groupId;
    const value = clickedBtn.dataset.value;
    const isAlreadyActive = clickedBtn.classList.contains('active');
    
    groupDiv.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));

    if (isAlreadyActive) {
      delete this.activeFilters[groupId];
    } else {
      clickedBtn.classList.add('active');
      this.activeFilters[groupId] = value;
    }

    this.filterAndSortProducts();
  }

  /**
   * 获取组合的辅助函数
   * 逻辑说明：标准的递归回溯。
   * 对于数组 [A, B, C]，取 k=2：
   * 1. 优先取前面的 -> [A, B] (相当于剔除了最后一个 C)
   * 2. 然后取 -> [A, C] (相当于剔除了倒数第二个 B)
   * 3. 最后取 -> [B, C] (相当于剔除了第一个 A)
   * 这个生成顺序完美符合需求中“先剔除最后一个，再剔除倒数第二个”的逻辑。
   */
  getCombinations(arr, k) {
    const results = [];
    function backtrack(start, combo) {
      if (combo.length === k) {
        results.push([...combo]);
        return;
      }
      for (let i = start; i < arr.length; i++) {
        combo.push(arr[i]);
        backtrack(i + 1, combo);
        combo.pop();
      }
    }
    backtrack(0, []);
    return results;
  }

  /**
   * 计算某产品在特定标签组合下的得分（用于同级排序）
   * @param {Object} product - 产品对象
   * @param {Array} tags - 当前匹配的标签数组
   * @returns {Number} - display_tags 命中的数量
   */
  calculateDisplayScore(product, tags) {
    let score = 0;
    tags.forEach(tag => {
      if (product.display_tags.includes(tag)) {
        score++;
      }
    });
    return score;
  }

  /**
   * 检查产品是否匹配了任何优先展示标签
   * @param {Object} product - 产品对象
   * @param {Array} selectedTags - 当前选中的标签数组
   * @returns {Boolean} - 是否匹配优先展示标签
   */
  hasPriorityTag(product, selectedTags) {
    // 检查选中的标签中是否有优先展示标签，且产品匹配了该标签
    return selectedTags.some(tag =>
      this.priorityTags.includes(tag) && product.filter_tags.includes(tag)
    );
  }

  /**
   * 核心筛选与排序算法（variant级别）
   * 优化点：在每一层匹配数量(k)的循环中，引入“层级候选池”。
   * 先收集该层级所有匹配的变体，然后根据显性标签(display_tags)的权重进行排序，
   * 确保：同为命中1个标签时，命中显性标签的变体排在命中隐性标签的变体前面。
   */
  filterAndSortProducts() {
    // 一、设置变量
    const maxResults = 6;
    const selectedTags = Object.values(this.activeFilters).sort();
    let finalResults = [];
    let seenVariantIds = new Set(); // 全局去重，防止同一个变体被多次添加

    // 二、多标签筛选逻辑 (瀑布流)
    if (selectedTags.length > 0) {

      // 循环 k：从匹配所有选中标签 (n) 开始，递减到 1
      for (let k = selectedTags.length; k >= 1; k--) {
        
        // --- 核心修改开始：创建当前层级的临时候选池 ---
        let layerCandidates = [];
        let layerSeenIds = new Set(); // 当前层级去重，防止同一变体在不同组合中重复出现

        // 1. 获取选中的 n 个标签中，取 k 个的所有组合
        const combinations = this.getCombinations(selectedTags, k);

        // 2. 遍历每一个组合
        for (const comboTags of combinations) {
          
          // 3. 在变体池中查找匹配当前组合的变体
          for (const variant of this.products) {
            // 如果已经在最终结果里了，跳过
            if (seenVariantIds.has(variant.id)) continue; 
            // 如果已经在当前层级的候选池里了，也跳过
            if (layerSeenIds.has(variant.id)) continue;

            // 严格匹配：变体必须包含当前组合内的所有标签
            const isMatch = comboTags.every(tag => variant.filter_tags.includes(tag));

            if (isMatch) {
              layerCandidates.push(variant);
              layerSeenIds.add(variant.id);
            }
          }
        }

        // 4. 【关键优化】在层级循环结束、加入最终结果之前，对 layerCandidates 进行排序
        // 逻辑：在匹配数量相同(k)的情况下，谁包含的“显性标签(display_tags)”更多，谁排前面。
        if (layerCandidates.length > 0) {
          layerCandidates.sort((a, b) => {
            // 注意：这里传入 selectedTags 而不是 comboTags
            // 我们要看在用户选中的所有标签里，变体命中了多少个显性标签
            const scoreA = this.calculateDisplayScore(a, selectedTags);
            const scoreB = this.calculateDisplayScore(b, selectedTags);
            return scoreB - scoreA; // 降序排列
          });

          // 5. 将排序后的当前层级结果加入最终结果
          for (const candidate of layerCandidates) {
            // 双重保险检查，虽然上面逻辑已经保证了唯一性
            if (!seenVariantIds.has(candidate.id)) {
              finalResults.push(candidate);
              seenVariantIds.add(candidate.id);
            }
          }
        }
        // --- 核心修改结束 ---
      }
    }

    // 三、兜底/补充逻辑 (保持不变)
    // 只有没有选中任何筛选项时，才补全到6个 (或者你可以根据需求决定是否在筛选结果不足6个时补全)
    // 这里的逻辑维持你原本的意图：仅当没有 activeFilters 时才补全，或者筛选结果太少时补全？
    // 根据你之前的代码逻辑，是 "如果没选中任何筛选项...才补全"。
    // 如果想要"筛选结果不足6个时也补全"，可以去掉 !hasActiveFilters 的判断，只保留 length 判断。
    // 这里保持你原有的逻辑：
    const hasActiveFilters = selectedTags.length > 0;

    if (!hasActiveFilters && finalResults.length < maxResults) {
      for (const variant of this.products) {
        if (finalResults.length >= maxResults) break;
        if (seenVariantIds.has(variant.id)) continue;
        if (variant.filter_tags && variant.filter_tags.length > 0) {
          finalResults.push(variant);
          seenVariantIds.add(variant.id);
        }
      }
    }

    // 四、优先展示排序 (全局优先，保持不变)
    if (selectedTags.length > 0 && this.priorityTags.length > 0) {
      finalResults.sort((a, b) => {
        const aPriority = this.hasPriorityTag(a, selectedTags) ? 1 : 0;
        const bPriority = this.hasPriorityTag(b, selectedTags) ? 1 : 0;
        return bPriority - aPriority; 
      });
    }

    // 五、截取前 maxResults 个结果
    if (finalResults.length > maxResults) {
      finalResults = finalResults.slice(0, maxResults);
    }

    // 六、渲染结果
    this.renderProducts(finalResults);
  }

  renderProducts(variantsToRender) {
    if (!variantsToRender.length) {
      this.resultsContainer.innerHTML = `<div class="no-results">${this.config.empty_text}</div>`;
      return;
    }

    const html = variantsToRender.map((variant, index) => {
      let badgeHtml = '';
      if (index === 0 && this.config.top1_icon && this.config.top1_icon.indexOf('no-image') === -1) {
        badgeHtml = `<img src="${this.config.top1_icon}" class="rank-badge" alt="Top 1">`;
      } else if (index === 1 && this.config.top2_icon && this.config.top2_icon.indexOf('no-image') === -1) {
        badgeHtml = `<img src="${this.config.top2_icon}" class="rank-badge" alt="Top 2">`;
      } else if (index === 2 && this.config.top3_icon && this.config.top3_icon.indexOf('no-image') === -1) {
        badgeHtml = `<img src="${this.config.top3_icon}" class="rank-badge" alt="Top 3">`;
      }

      const tagsHtml = variant.display_tags.map(tag =>
        `<span class="display-tag">${tag}</span>`
      ).join('');

      const comparePriceHtml = variant.compare_price
        ? `<span class="compare-price">${variant.compare_price}</span>`
        : '';

      const quoteHtml = variant.quote
          ? `<div class="card-quote three-rows">"${variant.quote}"</div>`
          : '';

      return `
        <a href="${variant.url}" class="product-card">
          ${badgeHtml}
          <div class="card-image-wrapper">
            <img src="${variant.image}" loading="lazy" class="card-image" alt="${variant.product_title}">
          </div>
          <div class="card-info">
            <div class="card-title-wrapper">
              <h3 class="card-title">${variant.product_title}</h3>
              <div class="card-tags">
                ${tagsHtml}
              </div>
              ${quoteHtml}
            </div>
            <div class="card-price-row">
              <div class="price-wrapper">
                <span class="current-price">${variant.price}</span>
                ${comparePriceHtml}
              </div>
              <button class="view-btn">View details ></button>
            </div>
          </div>
        </a>
      `;
    }).join('');

    this.resultsContainer.innerHTML = html;
  }
}

if (!window.customElements.get('product-filter-section')) {
  customElements.define('product-filter-section', ProductFilterSection);
}

class TagRowV2 extends HTMLElement {
  constructor() {
    super();
    this.container = this.querySelector('.tag-row-container');
    this.indicator = this.querySelector('.scroll-indicator');
    this.isOneRow = this.getAttribute('data-one-row') === 'true';

    this.supportsMouseDrag = !!(window.matchMedia && window.matchMedia('(pointer: fine)').matches);
    this.isHovered = false;
    this.isPointerDown = false;
    this.isDragging = false;
    this.dragStartX = 0;
    this.dragStartScrollLeft = 0;

    this.boundHandleScroll = this.handleScroll.bind(this);
    this.boundHandleMouseEnter = this.handleMouseEnter.bind(this);
    this.boundHandleMouseLeave = this.handleMouseLeave.bind(this);
    this.boundHandleMouseDown = this.handleMouseDown.bind(this);
    this.boundHandleMouseMove = this.handleMouseMove.bind(this);
    this.boundHandleMouseUp = this.handleMouseUp.bind(this);
    this.boundHandleClickCapture = this.handleClickCapture.bind(this);
    this.boundHandleIndicatorClick = this.handleIndicatorClick.bind(this);
  }

  connectedCallback() {
    if (this.isOneRow && this.container) {
      // 初始化检查是否溢出
      this.checkOverflow();
      
      // 监听窗口大小变化重新检查
      window.addEventListener('resize', this.boundCheckOverflow);
      
      // 监听滚动事件
      this.container.addEventListener('scroll', this.boundHandleScroll, { passive: true });

      if (this.indicator) {
        this.indicator.addEventListener('click', this.boundHandleIndicatorClick);
      }

      // PC 端：鼠标悬停出现抓手，并支持按住拖动横向滚动
      if (this.supportsMouseDrag) {
        this.container.addEventListener('mouseenter', this.boundHandleMouseEnter);
        this.container.addEventListener('mouseleave', this.boundHandleMouseLeave);
        this.container.addEventListener('mousedown', this.boundHandleMouseDown);
        // 捕获阶段拦截：拖动过就不触发 a 链接跳转
        this.container.addEventListener('click', this.boundHandleClickCapture, true);
      }
    }
  }

  disconnectedCallback() {
    if (this.isOneRow) {
      window.removeEventListener('resize', this.boundCheckOverflow);
    }

    if (this.container) {
      this.container.removeEventListener('scroll', this.boundHandleScroll);
      if (this.supportsMouseDrag) {
        this.container.removeEventListener('mouseenter', this.boundHandleMouseEnter);
        this.container.removeEventListener('mouseleave', this.boundHandleMouseLeave);
        this.container.removeEventListener('mousedown', this.boundHandleMouseDown);
        this.container.removeEventListener('click', this.boundHandleClickCapture, true);
      }
    }

    if (this.indicator) {
      this.indicator.removeEventListener('click', this.boundHandleIndicatorClick);
    }

    document.removeEventListener('mousemove', this.boundHandleMouseMove);
    document.removeEventListener('mouseup', this.boundHandleMouseUp);
  }

  // 绑定 resize 上下文
  boundCheckOverflow = () => {
    this.checkOverflow();
  }

  checkOverflow() {
    if (!this.container) return;
    if (!this.indicator) return;

    // scrollWidth > clientWidth 说明内容溢出
    const isOverflowing = this.container.scrollWidth > this.container.clientWidth;

    if (this.supportsMouseDrag && this.isHovered && !this.isPointerDown) {
      this.container.style.cursor = isOverflowing ? 'grab' : '';
    }
    
    // 只有当溢出且用户还没滚动过(indicator没有被标记为scrolled)时显示
    if (isOverflowing && !this.indicator.classList.contains('has-scrolled')) {
      this.indicator.classList.remove('hidden');
    } else {
      this.indicator.classList.add('hidden');
    }
  }

  handleScroll() {
    if (!this.indicator) return;

    // 用户一旦滑动一下，该指示就消失，不再出现
    // 添加一个 has-scrolled 标记，防止 resize 再次触发显示
    this.indicator.classList.add('hidden');
    this.indicator.classList.add('has-scrolled');
  }

  handleIndicatorClick(e) {
    if (!this.indicator) return;
    e.preventDefault();
    e.stopPropagation();
    this.indicator.classList.add('hidden');
    this.indicator.classList.add('has-scrolled');
  }

  handleMouseEnter() {
    this.isHovered = true;
    this.checkOverflow();
  }

  handleMouseLeave() {
    this.isHovered = false;
    if (!this.isPointerDown && this.container) {
      this.container.style.cursor = '';
    }
  }

  handleMouseDown(e) {
    if (!this.container) return;
    if (e.button !== 0) return;

    const isOverflowing = this.container.scrollWidth > this.container.clientWidth;
    if (!isOverflowing) return;

    this.isPointerDown = true;
    this.isDragging = false;
    this.dragStartX = e.pageX;
    this.dragStartScrollLeft = this.container.scrollLeft;

    this.container.style.cursor = 'grabbing';
    this.container.style.userSelect = 'none';

    document.addEventListener('mousemove', this.boundHandleMouseMove);
    document.addEventListener('mouseup', this.boundHandleMouseUp);

    e.preventDefault();
  }

  handleMouseMove(e) {
    if (!this.container) return;
    if (!this.isPointerDown) return;

    const dx = e.pageX - this.dragStartX;
    if (Math.abs(dx) > 3) this.isDragging = true;
    this.container.scrollLeft = this.dragStartScrollLeft - dx;

    if (this.isDragging) e.preventDefault();
  }

  handleMouseUp() {
    if (!this.container) return;
    if (!this.isPointerDown) return;

    this.isPointerDown = false;
    document.removeEventListener('mousemove', this.boundHandleMouseMove);
    document.removeEventListener('mouseup', this.boundHandleMouseUp);

    this.container.style.userSelect = '';

    const isOverflowing = this.container.scrollWidth > this.container.clientWidth;
    this.container.style.cursor = (this.isHovered && isOverflowing) ? 'grab' : '';
  }

  handleClickCapture(e) {
    if (!this.isDragging) return;
    e.preventDefault();
    e.stopPropagation();
    this.isDragging = false;
  }
}

// 注册 Web Component
if (!window.customElements.get('tag-row-v2')) {
  customElements.define('tag-row-v2', TagRowV2);
}

class CountdownTimer2 extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.deadlineStr = this.getAttribute('data-deadline');
    this.elements = {
      days: this.querySelector('[data-type="days"]'),
      hours: this.querySelector('[data-type="hours"]'),
      minutes: this.querySelector('[data-type="minutes"]'),
      seconds: this.querySelector('[data-type="seconds"]')
    };

    if (!this.deadlineStr) return;

    this.updateTimer();
    this.timerInterval = setInterval(() => this.updateTimer(), 1000);
  }

  disconnectedCallback() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }

  updateTimer() {
    // 兼容性处理：将 '-' 替换为 '/' 以支持 Safari
    const formattedDate = this.deadlineStr.replace(/-/g, '/'); 
    const deadline = new Date(formattedDate).getTime();
    const now = new Date().getTime();
    const diff = deadline - now;

    if (diff <= 0) {
      clearInterval(this.timerInterval);
      this.render(0, 0, 0, 0);
      return;
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    this.render(days, hours, minutes, seconds);
  }

  render(d, h, m, s) {
    if(this.elements.days) this.elements.days.textContent = this.pad(d);
    if(this.elements.hours) this.elements.hours.textContent = this.pad(h);
    if(this.elements.minutes) this.elements.minutes.textContent = this.pad(m);
    if(this.elements.seconds) this.elements.seconds.textContent = this.pad(s);
  }

  pad(num) {
    return num < 10 ? '0' + num : num;
  }
}

if (!window.customElements.get('countdown-timer2')) {
  customElements.define('countdown-timer2', CountdownTimer2);
}

/**
 * Class: CouponCopier
 * 功能: 处理点击复制按钮逻辑
 */
class CouponCopier extends HTMLElement {
  constructor() {
    super();
    this.handleCopy = this.handleCopy.bind(this);
  }

  connectedCallback() {
    this.codeToCopy = this.getAttribute('data-code');
    this.button = this.querySelector('button');
    
    if (this.button) {
      // 保存原始按钮文案 (Copy)，以便还原
      this.originalText = this.button.textContent;
      this.button.addEventListener('click', this.handleCopy);
    }
  }

  disconnectedCallback() {
    if (this.button) {
      this.button.removeEventListener('click', this.handleCopy);
    }
  }

  handleCopy() {
    if (!navigator.clipboard || !this.codeToCopy) {
      console.warn('Clipboard API not available or no code provided');
      return;
    }

    navigator.clipboard.writeText(this.codeToCopy)
      .then(() => {
        this.button.textContent = 'Copied';
        
        // 如果有之前的计时器，先清除，防止快速点击导致显示异常
        if (this.revertTimeout) {
          clearTimeout(this.revertTimeout);
        }

        this.revertTimeout = setTimeout(() => {
          this.button.textContent = this.originalText;
        }, 3000);
      })
      .catch(err => {
        console.error('Failed to copy text: ', err);
      });
  }
}

if (!window.customElements.get('coupon-copier')) {
  customElements.define('coupon-copier', CouponCopier);
}

class promoCard extends HTMLElement {
  constructor() {
    super();
    this.btn = this.querySelector('.js-add-to-cart');
    this.variantId = this.dataset.variantId;
    this.originalText = "Add to cart";
    this.isAnimating = false;
    
    if(this.btn) {
      this.btn.addEventListener('click', this.addToCart.bind(this));
    }
  }

  addToCart() {
    if(this.isAnimating || !this.variantId) return;
    this.isAnimating = true;

    // Start Animation
    this.startAnimation();

    // Add to Cart Logic
    let formData = {
      'items': [{
        'id': this.variantId,
        'quantity': 1
      }]
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      const event = new CustomEvent("cart:show");
      document.dispatchEvent(event); // 触发事件
      if(!document.body.classList.contains('smart-cart--enabled')) document.dispatchEvent(new CustomEvent("cart:refresh"));
    })
    .catch((error) => {
      console.error('Error:', error);
    })
    .finally(() => {
      setTimeout(() => {
        this.stopAnimation();
      }, 3000);
    });
  }

  startAnimation() {
    const span = this.btn.querySelector('.btn-text');
    let dots = 0;
    span.textContent = "Add to cart";
    
    this.animationInterval = setInterval(() => {
      dots = (dots + 1) % 4; 
      let dotStr = "";
      for(let i=0; i<dots; i++) dotStr += ".";
      span.textContent = "Add to cart" + dotStr;
    }, 500); 
  }

  stopAnimation() {
    clearInterval(this.animationInterval);
    const span = this.btn.querySelector('.btn-text');
    span.textContent = this.originalText;
    this.isAnimating = false;
  }
}

if (!window.customElements.get('custom-element-promo-card')) {
  customElements.define('custom-element-promo-card', promoCard);
}

// Feature Accordion 风琴组+图片组件
class FeatureAccordion extends HTMLElement {
  constructor() {
    super();
    this.allowMultiple = this.dataset.allowMultiple === 'true';

    // Elements
    this.items = this.querySelectorAll('.fa-item');
    this.desktopImages = this.querySelectorAll('.fa-desktop-image-item');

    this.init();
  }

  init() {
    this.items.forEach((item, index) => {
      const header = item.querySelector('.fa-item-header');

      // Click Event
      header.addEventListener('click', () => {
        this.toggleItem(index);
      });
    });

    // 从 data-default-open 属性读取默认打开的项目
    this.items.forEach((item, index) => {
      if (item.dataset.defaultOpen === 'true') {
        this.openItem(index);
      }
    });
  }

  toggleItem(index) {
    const item = this.items[index];
    const isOpen = item.classList.contains('open');

    if (!this.allowMultiple) {
      if (isOpen) {
        this.closeItem(index);
      } else {
        this.closeAll();
        this.openItem(index);
      }
    } else {
      if (isOpen) {
        this.closeItem(index);
      } else {
        this.openItem(index);
      }
    }
  }

  openItem(index) {
    if(!this.items[index]) return;

    this.items[index].classList.add('open');

    if(this.desktopImages[index]) {
      this.desktopImages.forEach(img => img.classList.remove('active'));
      this.desktopImages[index].classList.add('active');
    }
  }

  closeItem(index) {
    if(!this.items[index]) return;

    this.items[index].classList.remove('open');

    if(this.desktopImages[index]) {
      this.desktopImages[index].classList.remove('active');
    }
  }

  closeAll() {
    this.items.forEach((el, i) => {
      this.closeItem(i);
    });
  }
}

if (!window.customElements.get('feature-accordion')) {
  customElements.define('feature-accordion', FeatureAccordion);
}

// Custom: Order Support Chat Trigger
class OrderSupportChatTrigger extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick);

    if (document.querySelector('body > #chat-widget-container')) {
      this.onWidgetReady();
    } else {
      this.observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          for (const node of mutation.addedNodes) {
            if (node.id === 'chat-widget-container') {
              this.observer.disconnect();
              this.observer = null;
              this.onWidgetReady();
              return;
            }
          }
        }
      });
      this.observer.observe(document.body, { childList: true });
    }
  }

  onWidgetReady() {
    this.classList.remove('hidden');
  }

  handleClick() {
    try {
      if (typeof LiveChatWidget !== 'undefined') {
        document.body.classList.add('livechat-open');
        requestAnimationFrame(() => {
          LiveChatWidget.call('maximize');
        });
      }
    } catch (error) {
      console.error('OrderSupportChatTrigger: failed to open LiveChat', error);
    }
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
}

if (!window.customElements.get('order-support-chat-trigger')) {
  customElements.define('order-support-chat-trigger', OrderSupportChatTrigger);
}

// Pages页底部悬浮锚点按钮
class FloatingPageAnchor extends HTMLElement {
  constructor() {
    super();
    this.selectorStr = this.getAttribute("selector-str");
    this.nthDom = parseInt(this.getAttribute("nth-dom")) || 1;
    this.rewriteId = this.getAttribute("rewrite-id");
    this.targetDom = null;
    this.closeBanner = this.closeBanner.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.closeBtn = this.querySelector('#FloatingPageAnchorClose');
    this.container = this.querySelector('.fpa-container');
  }

  connectedCallback() {
    this.initTarget();
    // 立即展示，不需要滚动触发
    this.classList.add("show");
    if (this.closeBtn) {
      this.closeBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.closeBanner();
      });
    }
    if (this.container) {
      this.container.addEventListener("click", this.handleClick);
    }
  }

  disconnectedCallback() {
  }

  initTarget() {
    try {
      if (!this.selectorStr) return;
      if (this.nthDom - 1 < 0) return;
      const allElements = document.querySelectorAll(this.selectorStr);
      if (!allElements || allElements.length === 0) return;
      this.targetDom = allElements[this.nthDom - 1] || null;
      if (this.targetDom && this.rewriteId) {
        this.targetDom.setAttribute('id', this.rewriteId);
      }
    } catch (error) {
      console.error('FloatingPageAnchor initTarget error:', error);
    }
  }

  handleClick(e) {
    if (e.target.closest('.fpa-close-btn')) return;
    if (!this.targetDom) return;
    const targetId = this.targetDom.getAttribute('id');
    if (targetId) {
      const el = document.getElementById(targetId);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else {
      this.targetDom.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  closeBanner() {
    this.classList.remove("show");
    setTimeout(() => {
      this.style.display = 'none';
    }, 600);
  }
}

if (!window.customElements.get("floating-page-anchor")) {
  customElements.define("floating-page-anchor", FloatingPageAnchor);
}